(function () {
  'use strict';

  // -----------------------------------------------------------------------
  // Direct ?page=N landing on infinite-scroll collection pages renders only
  // page N's items (e.g. 6 of 54), looking broken. Redirect to root URL so
  // the user starts fresh from page 1 and infinite scroll loads naturally.
  // Runs ONCE at script init — Tinker/Globo's pushState during scroll won't
  // re-trigger this since the IIFE has already executed.
  (function redirectCollectionPagedLandings() {
    // Direct ?page=N>1 landing on a collection page renders only that page
    // (e.g. 6 of 54), looking broken. Strip ?page= so user starts fresh
    // from page 1; infinite scroll / Globo / pagination then load correctly.
    var url = new URL(window.location.href);
    if (!/^\/(?:[a-z]{2}\/)?collections\//.test(url.pathname)) return;
    var p = url.searchParams.get('page');
    if (!p || p === '1') return;
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  })();

  // -----------------------------------------------------------------------
  // Override Tinker + Globo control bar styles via injected <style> tag.
  // CDN/edge HTML cache may serve stale CSS, so we ship overrides via JS
  // — runtime styles win regardless of which CSS version was cached.
  function injectControlBarStyles() {
    if (document.getElementById('tk-globo-controlbar-style')) return;
    var s = document.createElement('style');
    s.id = 'tk-globo-controlbar-style';
    s.textContent = [
      '@media (max-width: 1024px) {',
      '  /* Filter+Sort row layout */',
      '  #gf-controls-container { padding: 0 !important; }',
      '  .gf-actions {',
      '    display: flex !important;',
      '    flex-wrap: wrap !important;',
      '    align-items: center !important;',
      '    justify-content: flex-end !important;',
      '    gap: 8px !important;',
      '    margin: 0 0 16px !important;',
      '    /* 4px inline = padding #gf-products → filtr/řazení lícují s kartami */',
      '    padding: 0 4px !important;',
      '    border: 0 !important; background: transparent !important;',
      '  }',
      '  /* Filter pushed left; sort pills group together on the right */',
      '  .gf-filter-trigger { margin-right: auto !important; }',

      '  /* Flatten the .gf-filter-selection wrapper so the 2 sort pills become',
      '     direct flex items of .gf-actions, alongside .gf-filter-trigger.',
      '     Otherwise sorts wrap *inside* the selection sub-row while filter sits',
      '     vertically centered as a separate column — looks broken. */',
      '  .gf-filter-selection {',
      '    display: contents !important;',
      '  }',

      '  /* Hide Globo .gf-summary span (flex: 1 1 auto pushes the sort group',
      '     to the right edge, leaving a huge gap after Filter button). */',
      '  .gf-summary { display: none !important; }',

      '  /* Filter trigger wrapper transparent (only the inner pill is visible).',
      '     margin-right: auto pushes filter to left, sorts group to right. */',
      '  .gf-filter-trigger {',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    margin: 0 auto 0 0 !important;',
      '    padding: 0 !important;',
      '    border: 0 !important; background: transparent !important; box-shadow: none !important;',
      '  }',

      '  /* Outer .gf-refine-toggle-mobile transparent */',
      '  .gf-refine-toggle-mobile,',
      '  .theme-store-id-3627.spf-filter-tree-theme.spf-has-filter #gf-controls-container .gf-refine-toggle-mobile {',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    margin: 0 !important; padding: 0 !important;',
      '    border: 0 !important; background: transparent !important;',
      '    /* radius matchuje vnitřní pill (span). Globo default občas namaluje',
      '       outer <a> bílý čtverec → bez radiusu prosvítaly bílé trojúhelníčky',
      '       v rozích za zaobleným pillem. radius 12 = rohy schované za pillem. */',
      '    box-shadow: none !important; border-radius: 12px !important;',
      '    height: 41px !important;',
      '  }',

      '  /* Single TK pill — applies to filter span AND both sort wrappers.',
      '     Specificity bumped (.gf-filter-selection .sort-by) to beat Globo',
      '     `.gf-filter-selection .sort-by { width: 100% }` at max-width 767. */',
      '  .gf-refine-toggle-mobile > span,',
      '  .gf-filter-selection .sort-by,',
      '  .gf-filter-selection .sort-by.limit-by,',
      '  .sort-by, .sort-by.limit-by {',
      '    width: auto !important;',
      '    flex: 0 0 auto !important;',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    justify-content: center !important;',
      '    gap: 8px !important;',
      '    height: 41px !important;',
      '    padding: 0 18px !important;',
      '    border: 1px solid rgba(0, 0, 0, 0.08) !important;',
      '    /* Card styl — identický se sort pill (radius 12 = mobilní karty + jemný stín). */',
      '    border-radius: 12px !important;',
      '    background: #fff !important;',
      '    color: #0a0a0a !important;',
      '    font-family: inherit !important;',
      '    font-size: 14px !important;',
      '    font-weight: 600 !important;',
      '    letter-spacing: 0.01em !important;',
      '    line-height: 1 !important;',
      '    white-space: nowrap !important;',
      '    cursor: pointer !important;',
      '    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04) !important;',
      '    margin: 0 !important;',
      '    transition: border-color 0.15s ease, transform 0.15s ease !important;',
      '  }',

      '  /* No hover animations — card pills, no transform/border-color change.',
      '     Border + soft shadow stay identical base↔hover (filtr i sort matchují). */',
      '  .gf-refine-toggle-mobile,',
      '  .gf-refine-toggle-mobile:hover,',
      '  .gf-refine-toggle-mobile:focus,',
      '  .gf-refine-toggle-mobile > span:hover,',
      '  .gf-refine-toggle-mobile > span:focus,',
      '  .gf-refine-toggle-mobile > span:focus-visible,',
      '  .sort-by:hover, .sort-by:focus,',
      '  .sort-by.limit-by:hover, .sort-by.limit-by:focus,',
      '  .gf-filter-selection .sort-by:hover,',
      '  .gf-filter-selection .sort-by.limit-by:hover {',
      '    border-color: rgba(0, 0, 0, 0.08) !important;',
      '    background: #fff !important;',
      '    transform: none !important;',
      '    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04) !important;',
      '    outline: none !important;',
      '    transition: none !important;',
      '  }',

      '  /* Filter inner SVG/icon size */',
      '  .gf-refine-toggle-mobile i, .gf-refine-toggle-mobile svg {',
      '    width: 16px !important; height: 16px !important; flex-shrink: 0 !important; margin: 0 !important;',
      '  }',

      '  /* Inner .gf-refine-toggle (if present) must not add another border */',
      '  .gf-refine-toggle-mobile .gf-refine-toggle {',
      '    border: 0 !important; padding: 0 !important; background: transparent !important;',
      '  }',

      '  /* Sort label + custom button text — match the pill type style */',
      '  .sort-by label, .sort-by .sort-by-toggle {',
      '    font-family: inherit !important;',
      '    font-size: 14px !important; font-weight: 600 !important;',
      '    color: #0a0a0a !important; line-height: 1 !important;',
      '    margin: 0 !important; padding: 0 !important; border: 0 !important;',
      '    background: transparent !important;',
      '    cursor: pointer !important;',
      '    white-space: nowrap !important;',
      '    box-shadow: none !important;',
      '    display: inline-flex !important; align-items: center !important; gap: 6px !important;',
      '  }',

      '  /* Native select inside .limit-by — hide native chevron + use custom one */',
      '  .sort-by select.sortby-select {',
      '    appearance: none !important; -webkit-appearance: none !important;',
      '    background: transparent !important; border: 0 !important;',
      '    margin: 0 !important; padding: 0 16px 0 4px !important;',
      '    font: inherit !important; font-weight: 600 !important;',
      '    color: #0a0a0a !important;',
      '    cursor: pointer !important;',
      '    width: auto !important; height: auto !important; line-height: 1 !important;',
      '    background-image: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\' viewBox=\'0 0 10 6\' fill=\'none\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%230a0a0a\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") !important;',
      '    background-repeat: no-repeat !important;',
      '    background-position: right 0 center !important;',
      '    background-size: 10px 6px !important;',
      '  }',

      '  /* Custom dropdown chevron for .sort-by-toggle (pure-button variant) */',
      '  .sort-by .sort-by-toggle::after {',
      '    content: "" !important;',
      '    display: inline-block !important;',
      '    width: 10px !important; height: 6px !important;',
      '    background: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\' viewBox=\'0 0 10 6\' fill=\'none\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%230a0a0a\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") no-repeat center / contain !important;',
      '    margin-left: 4px !important;',
      '  }',

      '  /* Hide any pseudo-chevron from theme (avoid double arrow) */',
      '  .sort-by::before, .sort-by::after,',
      '  .sort-by.limit-by::before, .sort-by.limit-by::after {',
      '    content: none !important; display: none !important;',
      '  }',
      '}',

      '/* Restore per-filter Clear link (Tinker theme hides it). Match its',
      '   exact selector + later source order = override. */',
      '.theme-store-id-3627.spf-filter-tree-theme.spf-has-filter .gf-option-block .gf-block-title .gf-clear {',
      '  display: inline-block !important;',
      '  cursor: pointer;',
      '  text-decoration: underline;',
      '  font-size: 12px;',
      '  color: #6b6b6b;',
      '  margin-left: auto;',
      '  flex-shrink: 0;',
      '}',
      '.theme-store-id-3627.spf-filter-tree-theme.spf-has-filter .gf-option-block .gf-block-title .gf-clear:hover {',
      '  color: #0a0a0a;',
      '}',

      '/* Show selected-items summary on all screens (template hardcodes',
      '   `visible-xs` which limits to mobile). Plus a "Clear all" link. */',
      '#gf-tree .globo-selected-items-wrapper {',
      '  display: block !important;',
      '  margin: 0 0 12px !important;',
      '  padding: 0 0 12px !important;',
      '  border-bottom: 1px solid #e5e5e5;',
      '}',
      '#gf-tree .globo-selected-items-wrapper:not(:has(.selected-item)) {',
      '  display: none !important;',
      '}',
      '/* "Filtrovat" heading nad vybranými filtry odstraněn (redundantní, žral',
      '   celý řádek). Clear-all "Vymazat vše" přesunut INLINE mezi pilulky',
      '   (.clear-refinements je první dítě .gf-block-content) → vše na jednom',
      '   zalamovacím řádku = úspora místa. */',
      '#gf-tree .globo-selected-items-wrapper .gf-block-title { display: none !important; }',
      '#gf-tree .globo-selected-items-wrapper .gf-block-content {',
      '  display: flex !important;',
      '  flex-wrap: wrap !important;',
      '  gap: 6px !important;',
      '  padding: 0 !important;',
      '  background: transparent !important;',
      '  border: 0 !important;',
      '}',
      '/* Vymazat vše — kompaktní obdélníkový chip s × na konci řádku pilulek. */',
      '#gf-tree .globo-selected-items-wrapper .clear-refinements {',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  gap: 5px !important;',
      '  order: 99 !important;',
      '  margin: 0 !important;',
      '  padding: 4px 10px !important;',
      '  font-size: 11.5px !important;',
      '  font-weight: 600 !important;',
      '  line-height: 1 !important;',
      '  color: var(--tk-ink, #0a0a0a) !important;',
      '  background: #fff !important;',
      '  border: 1px solid var(--tk-line, #e5e5e5) !important;',
      '  border-radius: var(--qty-radius, 8px) !important;',
      '  cursor: pointer !important;',
      '  white-space: nowrap !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .clear-refinements::before {',
      '  content: "\\00d7";',
      '  font-size: 14px !important;',
      '  line-height: 1 !important;',
      '  margin-top: -1px;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .clear-refinements:hover {',
      '  background: var(--tk-ink, #0a0a0a) !important;',
      '  color: #fff !important;',
      '  border-color: var(--tk-ink, #0a0a0a) !important;',
      '}',

      '/* Each selected filter is a compact pill: label-name (small grey) +',
      '   value (bold ink) + X close icon, all on one line. */',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label {',
      '  display: inline-flex !important;',
      '  align-items: center;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  border: 0 !important;',
      '  background: transparent !important;',
      '  width: auto !important;',
      '  max-width: 100% !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label > a {',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  gap: 6px !important;',
      '  padding: 4px 8px 4px 10px !important;',
      '  border: 1px solid #e5e5e5 !important;',
      '  border-radius: var(--qty-radius, 8px) !important;',
      '  background: #fafafa !important;',
      '  color: inherit !important;',
      '  text-decoration: none !important;',
      '  cursor: pointer !important;',
      '  line-height: 1 !important;',
      '  white-space: nowrap !important;',
      '  max-width: 100% !important;',
      '  overflow: hidden;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label > a:hover {',
      '  background: #fff !important;',
      '  border-color: #0a0a0a !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .selected-item {',
      '  display: inline-flex !important;',
      '  align-items: baseline !important;',
      '  gap: 4px;',
      '  flex-direction: row !important;',
      '  min-width: 0;',
      '  overflow: hidden;',
      '  text-overflow: ellipsis;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .selected-item > span:not(.hidden-xs) { display: none !important; }',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .selected-item .hidden-xs {',
      '  display: inline !important;',
      '  font-size: 11px !important;',
      '  font-weight: 400 !important;',
      '  color: #6b6b6b !important;',
      '  letter-spacing: 0 !important;',
      '  text-transform: none !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label strong {',
      '  font-weight: 600 !important;',
      '  font-size: 12px !important;',
      '  color: #0a0a0a !important;',
      '  overflow: hidden;',
      '  text-overflow: ellipsis;',
      '  max-width: 140px;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label strong .gf-label {',
      '  font-size: 12px !important; font-weight: 600 !important; color: #0a0a0a !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .gf-clear {',
      '  display: inline-flex !important;',
      '  align-items: center;',
      '  justify-content: center;',
      '  width: 14px !important;',
      '  height: 14px !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  border: 0 !important;',
      '  background: transparent !important;',
      '  color: #999 !important;',
      '  flex-shrink: 0;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .gf-clear svg {',
      '  width: 14px !important; height: 14px !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label > a:hover .gf-clear { color: #0a0a0a !important; }',

      '/* Per-filter "Vymazat" link (next to filter title) — smaller + subtle. */',
      '#gf-tree .gf-option-block .gf-block-title .gf-clear {',
      '  font-size: 11px !important;',
      '  font-weight: 400 !important;',
      '  color: #6b6b6b !important;',
      '  text-decoration: none !important;',
      '  border-bottom: 1px solid #c5c5c5;',
      '  line-height: 1 !important;',
      '  padding: 0 !important;',
      '  margin-left: 8px !important;',
      '}',
      '#gf-tree .gf-option-block .gf-block-title .gf-clear:hover {',
      '  color: #0a0a0a !important;',
      '  border-bottom-color: #0a0a0a !important;',
      '}',

      '/* Compact filter tree text on tablet/mobile drawer */',
      '@media (max-width: 1024px) {',
      '  /* Kompaktnější drawer (user: vše moc velké) — hutnější spacing. */',
      '  #gf-tree { font-size: 12px !important; }',
      '  #gf-tree .gf-option-block { padding: 8px 0 !important; }',
      '  #gf-tree .gf-block-title .h3 span { font-size: 12.5px !important; }',
      '  #gf-tree .gf-label { font-size: 12.5px !important; }',
      '  #gf-tree .gf-count { font-size: 11px !important; }',
      '  /* Search input — bigger left padding so text never overlaps the icon.',
      '     iOS Safari auto-zooms inputs whose font-size is < 16px, jerking the',
      '     viewport on focus. Force 16px here to suppress that. */',
      '  #gf-tree .gf-search {',
      '    font-size: 16px !important;',
      '    padding: 7px 10px 7px 28px !important;',
      '    background-position: 8px 50% !important;',
      '    background-size: 14px !important;',
      '    height: auto !important;',
      '  }',
      '  #gf-tree .gf-range-inputs input[type="text"] {',
      '    font-size: 16px !important;',
      '  }',
      '  #gf-tree .gf-block-content { padding-top: 4px !important; }',
      '  #gf-tree .gf-option-box li { padding: 0 !important; }',
      '  #gf-tree .gf-option-box li > div { padding: 0 !important; margin: 0 !important; }',
      '  #gf-tree .gf-option-box li a { padding: 3px 0 !important; line-height: 1.35 !important; }',
      '  #gf-tree .tk-filter-chip { font-size: 11px !important; padding: 3px 9px !important; }',
      '  #gf-tree .gf-range-inputs input { font-size: 12px !important; height: 30px !important; }',
      '}',

      '/* Compact option-list spacing applies to all viewports — current Globo',
      '   default ~44px per row is too airy. */',
      '#gf-tree .gf-option-box li { padding: 0 !important; margin: 0 !important; }',
      '#gf-tree .gf-option-box li > div { padding: 0 !important; margin: 0 !important; }',
      '#gf-tree .gf-option-box li a { padding: 5px 0 !important; }',
      '#gf-tree .gf-search { padding-left: 28px !important; background-position: 8px 50% !important; background-size: 14px !important; }',

      '/* Globo dropdown options + sort-by anchor — apply at all viewports. */',
      '.globo-dropdown-custom__options { z-index: 9999 !important; position: absolute !important; }',
      '.sort-by, .sort-by.limit-by { position: relative !important; z-index: 5; }',
      '.sort-by[aria-expanded="true"], .sort-by:has([aria-expanded="true"]) { z-index: 9999 !important; }',

      '/* Tighten vertical breathing room around the filter row — only at',
      '   tablet/mobile where every pixel counts. */',
      '@media (max-width: 1024px) {',
      '  results-list { padding-block-start: 0 !important; padding-block-end: 24px !important; margin-top: -10px !important; }',
      '  /* Search page: results-list jde HNED za .tk-search-section (žádný breadcrumb',
      '     mezi). Globální margin-top: -10px lepil produkty na search bar → override',
      '     jen pro tenhle adjacency case (kolekce s breadcrumbem netknuté). */',
      '  .tk-search-section + results-list { margin-top: 4px !important; }',
      '  .breadcrumb { padding-block: 10px 0 !important; margin: 0 !important; }',
      '  .breadcrumb nav, .breadcrumb ol, .breadcrumb ul { margin: 0 !important; padding: 0 !important; }',
      '  .breadcrumb a, .breadcrumb span, .breadcrumb li { font-size: 12px !important; line-height: 1.4 !important; }',
      '  #gf-controls-container { margin: 0 !important; padding: 0 !important; }',
      '  .gf-actions { margin: 0 0 8px !important; }',
      '}',

      '/* Small/medium screens — content-size pills, allow wrap to next row',
      '   if they do not fit. Drop the "Zobrazit" prefix to keep things tight. */',
      '@media (max-width: 540px) {',
      '  .gf-actions {',
      '    gap: 6px !important;',
      '    flex-wrap: wrap !important;',
      '    align-items: center !important;',
      '  }',

      '  /* Hide active-filters chip wrapper when empty (it has flex: 0 0 100%',
      '     which steals row width otherwise) */',
      '  .globo-selected-items-wrapper:empty,',
      '  .globo-selected-items-wrapper:not(:has(.selected-item)) {',
      '    display: none !important;',
      '  }',

      '  .gf-filter-selection {',
      '    gap: 6px !important;',
      '    flex-wrap: wrap !important;',
      '    flex: 0 1 auto !important;',
      '    min-width: 0 !important;',
      '    align-items: center !important;',
      '  }',

      '  .gf-refine-toggle-mobile > span,',
      '  .gf-filter-selection .sort-by,',
      '  .gf-filter-selection .sort-by.limit-by,',
      '  .sort-by, .sort-by.limit-by {',
      '    padding: 0 14px !important;',
      '    font-size: 13px !important;',
      '    /* Výška 41 = identická se sort pill (ten je zamčený CSS ID rulem). */',
      '    height: 41px !important;',
      '    gap: 6px !important;',
      '    flex: 0 0 auto !important;',
      '    width: auto !important;',
      '    max-width: 100% !important;',
      '    min-width: 0 !important;',
      '  }',

      '  /* Drop "Zobrazit" prefix label so the pill is just "24 ▼" */',
      '  .sort-by.limit-by label { display: none !important; }',

      '  /* Inner button gets natural width — no ellipsis unless really tight */',
      '  .sort-by .sort-by-toggle {',
      '    width: auto !important;',
      '    overflow: visible !important;',
      '    justify-content: center !important;',
      '  }',
      '  .sort-by .sort-by-toggle > span {',
      '    overflow: visible !important;',
      '    white-space: nowrap !important;',
      '    text-overflow: clip !important;',
      '  }',
      '  .sort-by select.sortby-select {',
      '    overflow: visible !important;',
      '    width: auto !important;',
      '    max-width: none !important;',
      '  }',

      '  .gf-refine-toggle-mobile i, .gf-refine-toggle-mobile svg {',
      '    width: 14px !important; height: 14px !important;',
      '  }',
      '}',

      '/* Tightest screens (≤360px): drop "Filtrovat" word, keep icon-only;',
      '   sort labels still natural — they will wrap to next row if needed. */',
      '@media (max-width: 360px) {',
      '  .gf-refine-toggle-mobile > span,',
      '  .gf-filter-selection .sort-by,',
      '  .gf-filter-selection .sort-by.limit-by,',
      '  .sort-by, .sort-by.limit-by {',
      '    padding: 0 10px !important;',
      '    font-size: 12px !important;',
      '    height: 41px !important;',
      '  }',
      '}',

      '/* Desktop (>1024px): řazení jako TK pill, stejně jako na mobilu. Filtr je',
      '   tady sidebar, takže v controls baru zůstane jen sort pill vpravo nad',
      '   gridem. (.gf-filter-trigger je na desktopu skrytý base pravidlem v CSS.)',
      '   ⚠️ Specificita: plain .sort-by:not(.limit-by) (0,2,0) PROHRÁVÁ s Globo/theme',
      '   border-resetem — nutný prefix #gf-controls-container .gf-actions',
      '   .gf-filter-selection (1,4,0). Ověřeno Playwrightem. */',
      '@media (min-width: 1025px) {',
      '  /* Posun Globo bloku nahoru (gap breadcrumb→filtrace byl 32px). Negativní',
      '     margin-top, NE padding-top — kvůli zarovnání skeleton overlaye. */',
      '  results-list { margin-top: -16px !important; }',
      '  /* Filter tree do bílého rámečku jako sort pill. Zrcadleno z CSS — runtime',
      '     <style> loaduje PO Globu, garantuje že bílá přebije Globo šedou #F6F7F9. */',
      '  #gf-tree {',
      '    align-self: flex-start !important;',
      '    background: #fff !important;',
      '    /* Border ve stylu produktových karet: průhledný border + jemný shadow + 16px. */',
      '    border: 1px solid transparent !important;',
      '    border-radius: 16px !important;',
      '    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04) !important;',
      '    padding: 6px 16px 14px !important;',
      '  }',
      '  /* Karty do page-width vpravo (#gf-grid margin-right -24 symetricky k tree',
      '     margin-left -24) + na úroveň vršku tree (#gf-grid padding-top Globo 8→0)',
      '     + menší mezera tree↔karty (#gf-grid padding-left Globo 25→0)',
      '     + zrušit pravý 4px card inset (#gf-products padding-right). */',
      '  #gf-grid { padding-top: 0 !important; padding-left: 0 !important; margin-right: -24px !important; }',
      '  #gf-products { padding-right: 0 !important; }',
      '  /* SEARCH desktop (2026-09-16): Globo 1092 rendruje tree na search INLINE',
      '     jako sidebar (dřív off-canvas) → search jede na stejných offsetech jako',
      '     kolekce, dřívější `#MainContent:has(.tk-search-row)` override je pryč.',
      '     Navíc do TÉHOŽ flex řádku vkládá `#gf-search-tabs` (Produkty / Kolekce),',
      '     který se bez tohohle stal třetím sloupcem a překryl obsah. Wrap + order -1',
      '     + basis 100 % → taby mají vlastní řádek nad tree+grid. SYNC s CSS. */',
      '  #ResultsList > div:has(> #gf-search-tabs) { flex-wrap: wrap !important; }',
      '  #gf-search-tabs { order: -1 !important; flex: 0 0 100% !important; width: 100% !important; margin: 0 !important; }',
      '  /* KOLEKCE: sort vpravo DO breadcrumbu. Flex+center+min-height 61 BEZPODMÍNEČNĚ',
      '     (ne :has(#gf-controls-container)) — jinak block→flex skok drobečků po přidání',
      '     sortu (JS ho přidá až po paintu). Bezpodmínečně = drobečky vycentrované od',
      '     prvního paintu, sort se přidá bez reflow. */',
      '  .breadcrumb:has(~ results-list) {',
      '    display: flex !important;',
      '    align-items: center !important;',
      '    justify-content: space-between !important;',
      '    gap: 16px !important;',
      '    flex-wrap: wrap !important;',
      '    min-height: 67px;',
      '  }',
      '  .breadcrumb #gf-controls-container { margin: 6px 0 0 !important; padding: 0 !important; }',
      '  #gf-controls-container .gf-filter-selection { padding: 0 !important; }',
      '  .breadcrumb #gf-controls-container .gf-actions { margin: 0 !important; padding: 0 !important; }',
      '  /* SEARCH: sort do search-form řádku (vedle search baru) — analogie breadcrumbu. */',
      '  .tk-search-row { flex-direction: row !important; align-items: center !important; gap: 16px !important; margin: 0 !important; }',
      '  .tk-search-row > search-page-input-component { flex: 1 1 auto !important; min-width: 0 !important; }',
      '  .tk-search-row > #gf-controls-container { flex: 0 0 auto !important; margin: 0 !important; padding: 0 !important; }',
      '  .tk-search-row > #gf-controls-container .gf-actions { justify-content: flex-end !important; margin: 0 !important; padding: 0 !important; }',
      '  #gf-controls-container { padding: 0 !important; }',
      '  #gf-controls-container .gf-actions {',
      '    display: flex !important;',
      '    align-items: center !important;',
      '    justify-content: flex-end !important;',
      '    gap: 8px !important;',
      '    margin: 0 0 20px !important;',
      '    /* 4px inline = padding #gf-products → pill lícuje s pravým krajem karet. */',
      '    padding: 0 4px !important;',
      '    border: 0 !important; background: transparent !important; box-shadow: none !important;',
      '  }',
      '  /* gf-summary (flex:1 počet výsledků) skrýt — pill se drží u pravého kraje. */',
      '  #gf-controls-container .gf-actions .gf-summary { display: none !important; }',
      '  #gf-controls-container .gf-actions .gf-filter-selection {',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    gap: 8px !important;',
      '    margin: 0 !important;',
      '    flex: 0 0 auto !important;',
      '  }',
      '  /* Sort pill (ne .limit-by — ten je per-page selector, skrytý). */',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by) {',
      '    width: auto !important;',
      '    flex: 0 0 auto !important;',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    justify-content: center !important;',
      '    gap: 8px !important;',
      '    height: 41px !important;',
      '    padding: 0 18px !important;',
      '    /* Border ve stylu produktových karet: průhledný border + shadow + 12px. */',
      '    border: 1px solid transparent !important;',
      '    border-radius: 12px !important;',
      '    background: #fff !important;',
      '    color: #0a0a0a !important;',
      '    font-family: inherit !important;',
      '    font-size: 14px !important;',
      '    font-weight: 600 !important;',
      '    letter-spacing: 0.01em !important;',
      '    line-height: 1 !important;',
      '    white-space: nowrap !important;',
      '    cursor: pointer !important;',
      '    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04) !important;',
      '    margin: 0 !important;',
      '    transition: box-shadow 0.15s ease !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by):hover {',
      '    box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08), 0 4px 12px rgba(15, 23, 42, 0.08) !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by) label,',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by) .sort-by-toggle {',
      '    font-family: inherit !important;',
      '    font-size: 14px !important; font-weight: 600 !important;',
      '    color: #0a0a0a !important; line-height: 1 !important;',
      '    margin: 0 !important; padding: 0 !important; border: 0 !important;',
      '    background: transparent !important; cursor: pointer !important;',
      '    white-space: nowrap !important; box-shadow: none !important;',
      '    display: inline-flex !important; align-items: center !important; gap: 6px !important;',
      '  }',
      '  /* Vlastní chevron na .sort-by-toggle::after; Globo pseudo na .sort-by zabít. */',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by)::before,',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by)::after {',
      '    content: none !important; display: none !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by) .sort-by-toggle::after {',
      '    content: "" !important;',
      '    display: inline-block !important;',
      '    width: 10px !important; height: 6px !important;',
      '    background: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\' viewBox=\'0 0 10 6\' fill=\'none\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%230a0a0a\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") no-repeat center / contain !important;',
      '    margin-left: 4px !important;',
      '  }',
      '}',
    ].join('\n');
    document.head.appendChild(s);
  }

  // -----------------------------------------------------------------------
  // Variant URL sync — when Globo filter is active (e.g. productdevice =
  // "Apple Watch 10 42 mm"), each product card link should point to the
  // variant matching that filter, not product.selected_or_first_available_variant
  // (which Globo defaults to). Card carries `data-tk-variants` JSON map of
  // variant_id → array of option values; we match against URL gf_* params.
  function getActiveGloboFilterValues() {
    var url = new URL(window.location.href);
    var values = [];
    url.searchParams.forEach(function (val, key) {
      if (/^gf_\d+$/.test(key) && val) {
        // Globo encodes multiple values with comma; split and trim.
        val.split(',').forEach(function (v) {
          v = v.trim();
          if (v) values.push(v);
        });
      }
    });
    return values;
  }

  // Cache product.js fetches per handle (resolves to {variants: [{id, options:[...]}, ...]})
  var productDataCache = {};
  function getProductData(handle) {
    if (productDataCache[handle]) return productDataCache[handle];
    var locale = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    productDataCache[handle] = fetch(locale + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productDataCache[handle];
  }

  function getCardHandle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function pickBestVariantFromProduct(product, filterValues) {
    if (!product || !product.variants) return null;
    var bestId = null;
    var bestScore = 0;
    product.variants.forEach(function (v) {
      var opts = v.options || [];
      var score = 0;
      filterValues.forEach(function (fv) {
        if (opts.some(function (o) { return o === fv; })) score++;
      });
      if (score > bestScore) { bestScore = score; bestId = v.id; }
    });
    return bestId;
  }

  function findMatchingVariantId(card, filterValues) {
    if (!filterValues.length) return null;
    // 1) Server-rendered map (preferred — instant, no network)
    var raw = card.getAttribute('data-tk-variants');
    if (raw) {
      try {
        var map = JSON.parse(raw);
        var bestId = null;
        var bestScore = 0;
        Object.keys(map).forEach(function (vid) {
          var opts = map[vid];
          if (!Array.isArray(opts)) return;
          var score = 0;
          filterValues.forEach(function (fv) {
            if (opts.some(function (o) { return o === fv; })) score++;
          });
          if (score > bestScore) { bestScore = score; bestId = vid; }
        });
        // Server mapa je AUTORITATIVNÍ — staví se z product.variants (VŠECHNY
        // varianty produktu). Když nenajde shodu, žádná varianta nematchuje
        // a fetch /products/<handle>.js by vrátil totéž (null). Vracíme rovnou
        // (i null) BEZ fetche. Tím se eliminují desítky zbytečných .js fetchů
        // na nevariantních filtrech (kapacita, typ, cena, dostupnost…) — jen
        // Barva je variantní opce, ostatní by se nikdy nenamatchovaly.
        return Promise.resolve(bestId);
      } catch (e) { /* malformovaná mapa → fallback fetch níže */ }
    }
    // Fallback jen když server mapa CHYBÍ (starší cache / jiný render path).
    var handle = getCardHandle(card);
    if (!handle) return Promise.resolve(null);
    return getProductData(handle).then(function (p) { return pickBestVariantFromProduct(p, filterValues); });
  }

  function applyCardVariantId(card, matchVid) {
    if (!matchVid) return;
    var currentVid = card.getAttribute('data-tk-variant-synced');
    if (String(currentVid) === String(matchVid)) return;
    card.setAttribute('data-tk-variant-synced', String(matchVid));
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try {
        var u = new URL(a.href);
        u.searchParams.set('variant', matchVid);
        a.href = u.toString();
      } catch (e) { /* ignore */ }
    });
    ['data-variant-id', 'data-selected-variant-id'].forEach(function (attr) {
      card.querySelectorAll('[' + attr + ']').forEach(function (el) {
        el.setAttribute(attr, String(matchVid));
      });
    });
    /* Re-render kartu na vyfiltrovanou variantu — image, is-selected swatch,
       cena. Bez tohohle Liquid render zůstane na první variantě (Globo runtime
       neumí předat filter context do product.selected_or_first_available_variant). */
    if (typeof window.TKReapplyCardVariant === 'function') {
      window.TKReapplyCardVariant(card);
    }
  }

  function applyVariantSync(filterValues) {
    if (!filterValues.length) return;
    var cards = document.querySelectorAll('product-card');
    cards.forEach(function (card) {
      var result = findMatchingVariantId(card, filterValues);
      if (result && typeof result.then === 'function') {
        result.then(function (vid) { applyCardVariantId(card, vid); });
      } else {
        applyCardVariantId(card, result);
      }
    });
  }

  function syncVariantsFromFilter() {
    var values = getActiveGloboFilterValues();
    if (!values.length) {
      // Clear sync flags so refilter starts fresh
      document.querySelectorAll('product-card[data-tk-variant-synced]').forEach(function (c) {
        c.removeAttribute('data-tk-variant-synced');
      });
    } else {
      applyVariantSync(values);
    }
    localizeProductLinks();
  }

  // -----------------------------------------------------------------------
  // Globo's product card template (snippets/globo.filter.product.liquid)
  // renders `{{ product.url }}` from Globo's render context, which is NOT
  // locale-aware — so on /en/ the cards link to `/products/foo` instead of
  // `/en/products/foo`. Click then drops user to default locale (CS).
  // Fix: prepend Shopify.routes.root prefix to any /products/... href that
  // is missing it, after every Globo render. Idempotent (skip if already
  // prefixed).
  function localizeProductLinks() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root === '/') return; // default locale — nothing to prefix
    var prefix = root.replace(/\/$/, ''); // '/en/' → '/en'
    if (!prefix) return;
    var grid = document.querySelector('#gf-products, ul.product-grid');
    if (!grid) return;
    var links = grid.querySelectorAll('a[href^="/products/"], a[href^="' + window.location.origin + '/products/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      // Skip if already locale-prefixed
      if (href.indexOf(prefix + '/products/') !== -1) continue;
      // Strip absolute origin if present so we work with pathname
      var pathStart = href.indexOf('/products/');
      if (pathStart < 0) continue;
      var newHref = href.slice(0, pathStart) + prefix + href.slice(pathStart);
      a.setAttribute('href', newHref);
    }
  }

  // -----------------------------------------------------------------------
  // EUR money format normalization: Shopify default EUR money_format renders
  // "€7,95" (symbol prefix). TK theme uses "7,95 €" (suffix) everywhere via
  // money-tk.liquid snippet. Globo's product card snippet runs in Globo's
  // own Liquid runtime inside {% raw %} block — it can't render theme
  // snippets, so it falls back to plain `| money` and prices come out with
  // the wrong format. Fix: rewrite "€X,XX" → "X,XX €" client-side after
  // every Globo render. Idempotent.
  function normalizeEurPrices(root) {
    var scope = root || document.body || document;
    if (!scope) return;
    // Include .noUi-value + .noUi-tooltip (slider pip labels co taky mají "€5,95" prefix)
    var nodes = scope.querySelectorAll('.price, .compare-at-price, .money, .noUi-value, .noUi-tooltip');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Skip nodes with child elements; touch only leaf text nodes
      if (el.children && el.children.length > 0) continue;
      var txt = el.textContent || '';
      // Match leading €, optional space, value, optional trailing space
      var m = txt.match(/^\s*€\s*([\d.,\s ]+?)\s*$/);
      if (!m) continue;
      el.textContent = m[1] + ' €';
    }
  }

  // CZK thousand separator normalization: Shopify default `| money` renders
  // "2,799 Kč" with comma as thousand separator (Anglosaxon convention),
  // ale Czech locale pouziva space ("2 799 Kč"). TK theme-side resi pres
  // money-tk.liquid snippet, ale Globo card snippet je uvnitr {% raw %} a
  // theme snippets nemuze renderovat -- fallback `| money` protece. Fix:
  // rewrite "X,XXX Kč" -> "X<nbsp>XXX<nbsp>Kč" client-side po kazdem Globo
  // renderu. Idempotent (skip pokud text nema carku ani regular space-Kc).
  function normalizeCzkPrices(root) {
    var scope = root || document.body || document;
    if (!scope) return;
    var nodes = scope.querySelectorAll('.price, .compare-at-price, .money');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children && el.children.length > 0) continue;
      var txt = el.textContent || '';
      if (txt.indexOf('Kč') < 0) continue;
      var hasComma = txt.indexOf(',') >= 0;
      var hasPlainSpaceKc = / Kč/.test(txt);
      if (!hasComma && !hasPlainSpaceKc) continue;
      var next = txt;
      if (hasComma) next = next.replace(/,/g, ' ');
      if (hasPlainSpaceKc) next = next.replace(/ Kč/g, ' Kč');
      if (next !== txt) el.textContent = next;
    }
  }

  // CZK Globo price-filter inputs: Globo's .gf-range-min / .gf-range-max
  // value attributy renderuje Globo runtime z money_without_format, co
  // produkuje napr. "2,799.00" (dot decimal + comma thousand) nebo "279.95".
  // Czech locale chce "2 799" (space thousand, zadne desetiny). Plus user
  // request: range konci na cele cislo (ceil pro max, floor pro min).
  // Skip pokud input je prave focusovany (user pise).
  // Gated na Shopify.currency.active === 'CZK' aby na EUR marketu (kde Globo
  // taky muze renderovat "7.95") nedoslo k rozbiti.
  function normalizeCzkGloboRangeInputs(root) {
    if (!window.Shopify || !window.Shopify.currency || window.Shopify.currency.active !== 'CZK') return;
    var scope = root || document.body || document;
    if (!scope) return;
    var inputs = scope.querySelectorAll('.gf-range-min, .gf-range-max');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (document.activeElement === input) continue;
      var raw = (input.value || '').trim();
      if (!raw) continue;
      // Strip thousand separators (comma, regular space, nbsp). Keep dot as decimal.
      var num = parseFloat(raw.replace(/[,\s ]/g, ''));
      if (isNaN(num)) continue;
      var isMin = input.classList.contains('gf-range-min');
      var rounded = isMin ? Math.floor(num) : Math.ceil(num);
      // Format with nbsp thousand separator
      var formatted = String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      if (input.value !== formatted) input.value = formatted;
    }
  }

  // EUR Globo price-filter inputs: Globo's money_without_format produkuje pro EUR
  // např. "7.95" nebo "1,234.56" (anglosaxon dot decimal + comma thousand). Czech
  // locale konvence (i pro EUR na cz market) chce comma decimal + space thousand:
  // "7,95" / "1 234,56". Skip pokud input je focused. Gated na Shopify.currency.active.
  // Idempotent — re-render Czech-format inputu ("7,95") rozparsuje správně.
  function normalizeEurGloboRangeInputs(root) {
    if (!window.Shopify || !window.Shopify.currency || window.Shopify.currency.active !== 'EUR') return;
    var scope = root || document.body || document;
    if (!scope) return;
    var inputs = scope.querySelectorAll('.gf-range-min, .gf-range-max');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (document.activeElement === input) continue;
      var raw = (input.value || '').trim();
      if (!raw) continue;
      // Locale-aware parse: rozhodnout co je decimal a co je thousand sep.
      var hasDot = raw.indexOf('.') >= 0;
      var hasComma = raw.indexOf(',') >= 0;
      var num;
      if (hasDot && hasComma) {
        // US format: comma=thousand, dot=decimal ("1,234.56")
        num = parseFloat(raw.replace(/,/g, '').replace(/\s/g, ''));
      } else if (hasDot) {
        // Dot only — decimal ("7.95")
        num = parseFloat(raw.replace(/\s/g, ''));
      } else if (hasComma) {
        // Comma only — Czech decimal pokud končí ,XX, jinak US thousand
        if (/,\d{1,2}$/.test(raw)) {
          num = parseFloat(raw.replace(/\s/g, '').replace(',', '.'));
        } else {
          num = parseFloat(raw.replace(/,/g, '').replace(/\s/g, ''));
        }
      } else {
        num = parseFloat(raw.replace(/\s/g, ''));
      }
      if (isNaN(num)) continue;
      // Has fractional part?
      var hasFraction = (Math.round(num * 100) % 100) !== 0;
      var formatted;
      if (hasFraction) {
        var parts = num.toFixed(2).split('.');
        formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1];
      } else {
        formatted = String(Math.round(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
      if (input.value !== formatted) input.value = formatted;
    }
  }

  // CZK noUiSlider pip + tooltip labels: Globo používá noUiSlider lib, který
  // rendruje pip labels (.noUi-value) podél kolejnice s defaultním thousand
  // separator = comma ("3,999 Kč", "30,000 mAh"). Czech locale chce space.
  // .noUi-tooltip se ukazuje při dragu s actual value — taky comma default.
  // Replace pattern: digit + comma + 3 digits + non-digit/end → digit + space + 3 digits.
  // Loop kvůli vícenásobným čárkám (miliony: "1,234,567"). Pattern preserves
  // decimal commas ("1,5 V") — pouze trojice digits po čárce se nahradí.
  function normalizeCzkNoUiLabels(root) {
    if (!window.Shopify || !window.Shopify.currency || window.Shopify.currency.active !== 'CZK') return;
    var scope = root || document.body || document;
    if (!scope) return;
    var nodes = scope.querySelectorAll('.noUi-value, .noUi-tooltip');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children && el.children.length > 0) continue;
      var txt = el.textContent || '';
      if (txt.indexOf(',') < 0) continue;
      var next = txt;
      var prev = '';
      while (next !== prev) {
        prev = next;
        next = next.replace(/(\d),(?=\d{3}(?:\D|$))/g, '$1 ');
      }
      if (next !== txt) el.textContent = next;
    }
  }

  // Non-price slidery (Max. celkový výkon W, Počet výstupů, Délka kabelu…) NESMÍ
  // nikdy zobrazit měnu ani money-style ".00"/",00" desetiny. Globo staví KAŽDÝ
  // slider noUiSliderem s defaultním 2-decimal formátovačem (důkaz: aria-valuetext
  // "140.00", URL gf_…=15.00:102.00) a při rebuildu po drag-apply umí prosáknout
  // měnový suffix cenového filtru ("Kč"/"€") na pips/inputy NE-cenového slideru
  // → uživatel viděl "150 Kč" u wattového slideru. normalizeCzkNoUiLabels řeší
  // jen oddělovač tisíců, "Kč" ze pipů nestripuje → tady to dočistíme.
  // Cenový blok (data-filter-type="Price") se NEDOTÝKÁME — jeho "132 Kč" je
  // legitimní. Idempotentní; běží z runSync + scan + noUiSlider 'update' hooku.
  function isPriceSliderBlock(block) {
    return (block.getAttribute('data-filter-type') || '').trim().toLowerCase() === 'price';
  }

  function stripMoneyTokens(txt) {
    if (!txt) return txt;
    return txt
      .replace(/\s*(?:Kč|CZK|€|EUR)\s*/g, '') // měnové tokeny kdekoliv
      .replace(/(\d)[.,]00(?!\d)/g, '$1')      // jen NULOVÉ desetiny: "140.00"→"140" (1,50 zůstane)
      .trim();
  }

  function stripCurrencyFromNonPriceSliders(root) {
    // root může být celý dokument NEBO jeden .gf-option-block (z 'update' hooku).
    // querySelectorAll('.gf-option-block') matchuje jen POTOMKY, takže když je
    // root sám blok, musíme ho zařadit explicitně.
    var blocks;
    if (root && root.classList && root.classList.contains('gf-option-block')) {
      blocks = [root];
    } else {
      var scope = root && root.querySelectorAll ? root : document;
      blocks = scope.querySelectorAll('.gf-option-block');
    }
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (!block.querySelector || !block.querySelector('.gf-range-slider')) continue;
      if (isPriceSliderBlock(block)) continue;
      var labels = block.querySelectorAll('.noUi-value, .noUi-tooltip');
      for (var j = 0; j < labels.length; j++) {
        var el = labels[j];
        if (el.children && el.children.length) continue;
        var t = el.textContent || '';
        var n = stripMoneyTokens(t);
        if (n !== t) el.textContent = n;
      }
      var inputs = block.querySelectorAll('.gf-range-min, .gf-range-max');
      for (var k = 0; k < inputs.length; k++) {
        var inp = inputs[k];
        if (document.activeElement === inp) continue;
        var iv = inp.value || '';
        var inn = stripMoneyTokens(iv);
        if (inn !== iv) inp.value = inn;
      }
    }
  }

  // ── Bug fix: zastaralý cenový slider po Globo AJAX morphu ──────────────────
  // Když uživatel aplikuje JINÝ filtr (např. výkon) a tím se zúží produkty,
  // Globo přepíše HTML cenového bloku (data-max + buňka → nový collection max,
  // 2999→2499), ALE NEreinicializuje noUiSlider instanci — ta drží starý rozsah
  // (range.max 2999, pip "2 999 Kč", handle na staré škále). Na full reloadu se
  // slider staví znovu z atributu → konzistentní; bug je JEN v AJAX-morph pathu
  // (drag-apply). Ověřeno empiricky: data-max="2499", ale slider.noUiSlider
  // .options.range.max === 2999. Fix: sesynchronizovat noUiSlider rozsah s
  // autoritativním data-min/data-max (Globo je přepisuje), přenastavit handly
  // z buněk a překreslit 2 pip endpointy. Fíruje JEN při reálném mismatchi
  // (v sync stavu no-op → žádná smyčka). updateOptions(…, false) + set() NEfírují
  // noUiSlider 'change' → Globo filtr se NEpřeaplikuje (set fíruje jen 'set'/'update').
  function fmtMoneyLabel(val) {
    var n = Number(val);
    if (isNaN(n)) return String(val);
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CZK';
    if (cur === 'CZK') {
      return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč';
    }
    var frac = Math.round(n * 100) % 100 !== 0;
    var s;
    if (frac) {
      var p = n.toFixed(2).split('.');
      s = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + p[1];
    } else {
      s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    return s + (cur === 'EUR' ? ' €' : '');
  }

  function reconcileStaleSliderRanges(root) {
    var blocks;
    if (root && root.classList && root.classList.contains('gf-option-block')) {
      blocks = [root];
    } else {
      var scope = root && root.querySelectorAll ? root : document;
      blocks = scope.querySelectorAll('.gf-option-block');
    }
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (!block.querySelector) continue;
      var slider = block.querySelector('.gf-range-slider');
      if (!slider || !slider.noUiSlider || typeof slider.noUiSlider.updateOptions !== 'function') continue;
      // Nesahej když uživatel právě interaguje v tomhle bloku (drag/psaní).
      if (block.contains(document.activeElement)) continue;
      var dMin = parseNum(slider.getAttribute('data-min'));
      var dMax = parseNum(slider.getAttribute('data-max'));
      if (isNaN(dMin) || isNaN(dMax) || dMax <= dMin) continue;
      var range = slider.noUiSlider.options.range || {};
      if (Number(range.min) === dMin && Number(range.max) === dMax) continue; // v sync → no-op
      // Cílové handly: z buněk (Globo je morphnul); fallback = clamp starého get().
      var cellMin = parseNum((block.querySelector('.gf-range-min') || {}).value);
      var cellMax = parseNum((block.querySelector('.gf-range-max') || {}).value);
      var cur = slider.noUiSlider.get();
      var curMin = parseNum(Array.isArray(cur) ? cur[0] : cur);
      var curMax = parseNum(Array.isArray(cur) ? cur[1] : cur);
      var newMin = !isNaN(cellMin) ? cellMin : (isNaN(curMin) ? dMin : curMin);
      var newMax = !isNaN(cellMax) ? cellMax : (isNaN(curMax) ? dMax : curMax);
      newMin = Math.max(dMin, Math.min(newMin, dMax));
      newMax = Math.max(dMin, Math.min(newMax, dMax));
      try {
        slider.noUiSlider.updateOptions({ range: { min: dMin, max: dMax } }, false);
        slider.noUiSlider.set([newMin, newMax]);
      } catch (e) { continue; }
      // Překreslit 2 pip endpointy autoritativně (updateOptions je regeneruje
      // defaultním formátem "2499.00" → u ceny dáme "2 499 Kč", jinak plain).
      var pips = slider.querySelectorAll('.noUi-value');
      if (pips.length >= 2) {
        var isPrice = isPriceSliderBlock(block);
        var loLabel = isPrice ? fmtMoneyLabel(dMin) : formatNum(dMin);
        var hiLabel = isPrice ? fmtMoneyLabel(dMax) : formatNum(dMax);
        if (pips[0].textContent.trim() !== loLabel) pips[0].textContent = loLabel;
        var last = pips[pips.length - 1];
        if (last.textContent.trim() !== hiLabel) last.textContent = hiLabel;
      }
    }
  }

  // Run after initial load + on AJAX re-render of the products grid.
  // Also re-runs the filter-tree scan() (label translations + sort + presets)
  // because Globo updates `.gf-label` textContent in-place — childList obs
  // on #gf-tree doesn't fire, so labels would otherwise leak CS after a
  // filter narrows the option set. Retry over ~700ms because Globo's DOM
  // update can land 100–300ms after our initial pushState-triggered scan.
  // Placeholder ve filter-tree search inputech: Globo dává na EN „Search
  // options" (uživateli se nelíbí) → přepiš na minimalističtější „Search".
  // CS „Vyhledat" necháváme (jen ho stylujeme v CSS). Idempotentní, běží
  // z runSync (Globo re-render placeholder resetuje).
  var SEARCH_PLACEHOLDER = { en: 'Search', sk: 'Hľadať' };
  function localizeFilterSearchPlaceholders() {
    var want = SEARCH_PLACEHOLDER[PAGE_LANG];
    if (!want) return;
    document.querySelectorAll('#gf-tree .gf-search').forEach(function (inp) {
      if (inp.placeholder !== want) inp.placeholder = want;
    });
  }

  // Záložky Produkty / Kolekce na search stránce (Globo 1092, #gf-search-tabs).
  // Globo je rendruje s HARDCODED anglickými popisky („Products", „Collections")
  // — v `GloboFilterTranslation.search` sice klíče `products`/`collections` jsou,
  // ale tabs je nečtou, takže na CS webu svítí angličtina. Přepíšeme je podle
  // `<html lang>`. Idempotentní, běží z runSync (Globo si tabs překresluje).
  var SEARCH_TAB_LABELS = {
    cs: { products: 'Produkty', collections: 'Kolekce', pages: 'Stránky', articles: 'Články' },
    sk: { products: 'Produkty', collections: 'Kolekcie', pages: 'Stránky', articles: 'Články' },
    en: { products: 'Products', collections: 'Collections', pages: 'Pages', articles: 'Articles' },
  };
  function localizeSearchTabs() {
    var map = SEARCH_TAB_LABELS[PAGE_LANG] || SEARCH_TAB_LABELS.en;
    document.querySelectorAll('#gf-search-tabs .gf-search-tab').forEach(function (btn) {
      var want = map[btn.getAttribute('data-tab')];
      if (!want) return;
      // Popisek je ve vlastním spanu (vedle spanu s počtem) — nikdy nepřepisuj
      // celý button, smazal bys počet i Globo handlery na children.
      var el = btn.querySelector('.gf-search-tab-label');
      if (el && el.textContent.trim() !== want) el.textContent = want;
    });
  }

  // Globo nastavuje #gf-tree šedé pozadí (#F6F7F9) selektorem se specificitou
  // VYŠŠÍ než (1,0,2) + !important — přebije i `html body #gf-tree !important`
  // (ověřeno escalation testem). Border/radius/align-self z CSS (tk-globo-filter.css
  // + injectControlBarStyles) projdou, jen `background` ne. Jediné co tu šedou
  // spolehlivě přebije je INLINE !important → nastavíme ho z JS po Globo renderu.
  // Desktop only (>1024px); na ≤1024 je tree off-canvas drawer, tam inline sundáme.
  function forceTreeFrameBg() {
    var tree = document.querySelector('#gf-tree');
    if (!tree) return;
    var isDesktop = !window.matchMedia || window.matchMedia('(min-width: 1025px)').matches;
    if (isDesktop) {
      if (tree.style.getPropertyValue('background') !== '#fff') {
        tree.style.setProperty('background', '#fff', 'important');
      }
    } else if (tree.style.getPropertyValue('background')) {
      tree.style.removeProperty('background');
    }
  }
  window.addEventListener('resize', forceTreeFrameBg);

  // Desktop (>1024px): přesunout celý #gf-controls-container (sort pill) na úroveň
  // breadcrumbu (vpravo). Přesouváme CELÝ #gf-controls-container (ne jen .gf-actions),
  // aby pill selektory `#gf-controls-container …` dál matchovaly; dropdown po přesunu
  // funguje (handlery delegované na document — ověřeno).
  //  • KOLEKCE (má breadcrumb) → sort vpravo DO breadcrumbu (stejný řádek jako drobečky).
  //  • SEARCH (nemá breadcrumb) → sort vpravo DO search-formu (`.search-page-input__parent`,
  //    server-rendrovaný v šedé sekci s třídou `.tk-search-row`, viz search-results.liquid
  //    + snippets/tk-search-bar.liquid). Form se NEpřesouvá — jen vložíme sort.
  //  • ≤1024 (off-canvas filter UX) → zpět do #gf-grid před #gf-products.
  function relocateControls() {
    var isDesktop = !window.matchMedia || window.matchMedia('(min-width: 1025px)').matches;
    var bc = document.querySelector('.breadcrumb');
    var form = document.querySelector('.search-page-input__parent'); // search-results bar form
    var grid = document.getElementById('gf-grid');
    // Dedup: pokud Globo re-renderoval čerstvý ctl v #gf-grid, zahodit dříve přesunuté.
    var all = document.querySelectorAll('#gf-controls-container');
    if (all.length > 1 && grid) {
      var inGrid = grid.querySelector('#gf-controls-container');
      if (inGrid) all.forEach(function (c) { if (c !== inGrid) c.remove(); });
    }
    var ctl = document.getElementById('gf-controls-container');
    if (!ctl) return;
    if (isDesktop && bc) {
      // KOLEKCE → sort do breadcrumbu (vpravo)
      if (ctl.parentElement !== bc) bc.appendChild(ctl);
    } else if (isDesktop && form) {
      // SEARCH → sort vpravo DO search-formu. Form je server-rendrovaný v šedé
      // sekci (search-results.liquid → snippets/tk-search-bar.liquid) s třídou
      // `tk-search-row` (flex-row se search barem) → form NEpřesouváme, jen vložíme
      // sort. Žádné poskakování (bar je už na místě, ne přesouvaný JS z headeru).
      if (ctl.parentElement !== form) form.appendChild(ctl);
    } else if (grid) {
      // MOBIL → sort do #gf-grid. Search bar zůstává v search-results (.tk-search-row
      // CSS se na <1025 neaplikuje → flex-column, jen search box).
      if (ctl.parentElement !== grid) {
        var products = document.getElementById('gf-products');
        grid.insertBefore(ctl, products || grid.firstChild);
      }
    }
  }
  window.addEventListener('resize', relocateControls);

  function runSync() {
    syncVariantsFromFilter();
    normalizeEurPrices();
    normalizeCzkPrices();
    normalizeCzkGloboRangeInputs();
    normalizeEurGloboRangeInputs();
    normalizeCzkNoUiLabels();
    reconcileStaleSliderRanges();
    stripCurrencyFromNonPriceSliders();
    localizeFilterSearchPlaceholders();
    localizeSearchTabs();
    forceTreeFrameBg();
    relocateControls();
    if (typeof scan === 'function') scan();
  }
  function scheduleSync() {
    requestAnimationFrame(runSync);
    // Retry to catch Globo's late DOM updates after pushState. Last 2 delays
    // (1500, 3000) zachytí pozdní noUiSlider init na velkých kolekcích.
    var delays = [80, 200, 400, 700, 1500, 3000];
    delays.forEach(function (d) { setTimeout(runSync, d); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
  // Re-sync when grid changes (Globo filter triggers AJAX morph)
  var gridObserver = new MutationObserver(function () { scheduleSync(); });
  // Observe products grid container if present, fallback to body
  var gridRoot = document.querySelector('#gf-products, ul.product-grid') || document.body;
  gridObserver.observe(gridRoot, { childList: true, subtree: true });
  // Re-sync on URL changes (Globo uses pushState for filter state)
  window.addEventListener('popstate', scheduleSync);
  // Vrátí true, pokud se URL mezi prev/next liší NANEJVÝŠ v parametru `page`
  // (a stejný pathname). To je signatura infinite-scroll paginace — Globo i
  // theme paginated-list při doscrollování pushují `?page=N`. Filter/sort
  // pushState mění gf_* / sort_by → vrátí false.
  function isPaginationOnlyChange(prevHref, nextHref) {
    try {
      var a = new URL(prevHref), b = new URL(nextHref);
      if (a.pathname !== b.pathname) return false;
      var keys = {};
      a.searchParams.forEach(function (_, k) { if (k !== 'page') keys[k] = 1; });
      b.searchParams.forEach(function (_, k) { if (k !== 'page') keys[k] = 1; });
      for (var k in keys) {
        if (a.searchParams.get(k) !== b.searchParams.get(k)) return false;
      }
      return true; // liší se nanejvýš `page` → paginace, ne filtr
    } catch (e) { return false; }
  }

  // Patch pushState to fire scheduleSync (Globo's own pushState calls)
  (function () {
    var origPush = history.pushState;
    history.pushState = function () {
      var prevHref = window.location.href;
      var ret = origPush.apply(this, arguments);
      // ⚠️ Infinite scroll používá pushState taky (`?page=N`). Patch je globální,
      // takže BEZ téhle gate chytal i pagination pushState a spouštěl scroll-to-top
      // korekci → viewport se uprostřed scrollování trhnul na vršek gridu a uživatel
      // se nedostal přes page 1 (donekonečna stejných 12 produktů). Wheel/touch abort
      // to obvykle maskoval, ale při flick-and-release na trackpadu (Mac) abort
      // nepřišel → bug se projevil. Při čisté paginaci proto scroll-korekci NEspouštět,
      // jen variant/price sync.
      if (isPaginationOnlyChange(prevHref, window.location.href)) {
        scheduleSync();
        return ret;
      }
      // Pokud pushState mění filter state (URL obsahuje gf_ params, případně
      // jakákoli změna na /collections/), naplánuj scroll-korekci. Sama funkce
      // si self-gatuje — scrollne JEN když je produkt grid mimo viewport.
      pendingScrollCorrection = true;
      scheduleSync();
      // Také zkusit hned (filter může přemorfovat grid synchronně).
      setTimeout(correctScrollAfterFilter, 80);
      setTimeout(correctScrollAfterFilter, 300);
      setTimeout(correctScrollAfterFilter, 700);
      return ret;
    };
  })();

  // -----------------------------------------------------------------------
  // UX při Globo filter apply.
  //
  // Symptom 1: user scrolluje uprostřed kolekce, zaškrtne filter co produkty
  //   zúží z 50+ na 2 → viewport zůstane na původní scrollY → kouká do patičky.
  // Symptom 2: Globo's AJAX trvá pár vteřin a nedává žádný visual feedback
  //   → user neví jestli se něco děje, klika znova.
  //
  // Řešení: na CLICK do filter triggeru hned (a) scrollnout viewport na top
  // stránky a (b) přidat .tk-is-filtering class na grid (spinner overlay
  // řeší CSS). gridObserver mutace pak class sundá, jakmile Globo nahradí
  // produkty. Fallback timeout 6 s pro případ že observer mutaci nezachytí.
  // -----------------------------------------------------------------------
  var pendingScrollCorrection = false;
  var loadingTimeout = null;

  // Zabraň browseru aby auto-restoroval scroll pozici při Globo's pushState
  // (`history.pushState` může triggrovat scroll-to-saved na některých verzích).
  if ('scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
  }

  // Auto-scroll na začátek produktů po aplikaci filtru.
  // Problém minulých verzí: jednorázový scroll (smooth i instant) doskočil
  // mimo, protože layout gridu se po Globo swapu ještě dlouho hýbe — Globo
  // dorenderovává karty, náš JS injektuje swatche/rating/discount pill a
  // relokuje sort bar NAD gridem. Řešení: po morphi DRŽÍME první kartu přesně
  // pod sticky headerem krátkým rAF korektorem — každý frame dorovnáme pozici
  // na ŽIVĚ změřenou spodní hranu headeru (ne --header-height, to bylo
  // nespolehlivé), dokud se layout neustálí. Přeruší se, jakmile uživatel
  // sám zascrolluje (wheel/touch/key) — ať se s ním JS nepere.

  function getScrollAnchor() {
    // Hidden-box placeholdery (Globo's 5 li's na konci) + #gf-empty skipni.
    var card = document.querySelector(
      '#gf-products > li:not(.hidden-box):not(.gf-empty),' +
      ' #gf-products .product-grid__item:not(.hidden-box),' +
      ' ul.product-grid > li.product-grid__item:not(.hidden-box)'
    );
    return card ||
           document.querySelector('#gf-products') ||
           document.querySelector('ul.product-grid');
  }

  // Živá spodní hrana sticky headeru (kam má začínat obsah) + 12 px mezera.
  function stickyHeaderBottom() {
    var h = document.querySelector('.tk-header[sticky]') ||
            document.querySelector('.tk-header');
    if (!h) return 12;
    var box = h.closest('.header-section') || h;
    var b = box.getBoundingClientRect().bottom;
    if (b < 0) b = 0; // header odscrollovaný pryč (ne-sticky stav)
    return b + 12;
  }

  // Dorovná vršek první karty na hranici pod headerem — ALE jen směrem NAHORU.
  // delta = (vršek 1. karty ve viewportu) − (spodek sticky headeru)
  //       = cílový scrollY − aktuální scrollY.
  //   delta < 0  → uživatel je POD začátkem produktů (scrollnutý dolů do
  //                gridu) → posuň ho NAHORU na cíl.
  //   delta >= 0 → uživatel je U/NAD začátkem produktů → NEHÝBEJ s ním
  //                (filtr ho nesmí trhat dolů, když je nahoře u filtrů/breadcrumbu).
  // Vrací zbytkovou odchylku (px) nebo null, pokud anchor ještě neexistuje.
  function alignAnchorToHeader() {
    var a = getScrollAnchor();
    if (!a) return null;
    var delta = a.getBoundingClientRect().top - stickyHeaderBottom();
    if (delta < -1) { window.scrollBy(0, delta); return Math.abs(delta); }
    return 0; // u/nad cílem → považuj za zarovnané, žádný scroll
  }

  var scrollCorrectRaf = 0;
  var userScrolledDuringCorrect = false;
  function onUserScrollAbort() { userScrolledDuringCorrect = true; }
  function stopScrollCorrect() {
    if (scrollCorrectRaf) cancelAnimationFrame(scrollCorrectRaf);
    scrollCorrectRaf = 0;
    window.removeEventListener('wheel', onUserScrollAbort);
    window.removeEventListener('touchstart', onUserScrollAbort);
    window.removeEventListener('keydown', onUserScrollAbort);
  }

  // Nastaví gridObserver, když Globo doručí nové produkty (morph) — korektor
  // (běžící od kliku) podle toho pozná, že má držet NOVOU 1. kartu a smí skončit
  // až PO morphi + ustálení (ne hned po zarovnání staré karty).
  var gridMutatedSinceScroll = false;
  function scrollToTopForFilter() {
    stopScrollCorrect();
    userScrolledDuringCorrect = false;
    gridMutatedSinceScroll = false;
    window.addEventListener('wheel', onUserScrollAbort, { passive: true });
    window.addEventListener('touchstart', onUserScrollAbort, { passive: true });
    window.addEventListener('keydown', onUserScrollAbort);

    var frames = 0, stable = 0;
    function correct() {
      if (userScrolledDuringCorrect) { stopScrollCorrect(); return; }
      var residual = alignAnchorToHeader();
      if (residual === null) {
        // Grid ještě prázdný (Globo nedoručil HTML) — čekej.
        if (frames++ < 300) { scrollCorrectRaf = requestAnimationFrame(correct); }
        else { stopScrollCorrect(); }
        return;
      }
      if (residual <= 1) { stable++; } else { stable = 0; }
      // Konec až KDYŽ se grid přemorfoval (Globo doručil nové produkty) A pozice
      // je ~10 framů stabilní. Díky tomu scroll může začít HNED na klik (drží
      // starou 1. kartu pod headerem) a po morphi plynule podrží novou. Hard cap
      // ~5 s pokryje i pomalé Globo (/all ~2,5 s) + případ filtru beze změny.
      if ((stable >= 10 && gridMutatedSinceScroll) || frames++ >= 300) { stopScrollCorrect(); return; }
      scrollCorrectRaf = requestAnimationFrame(correct);
    }
    scrollCorrectRaf = requestAnimationFrame(correct);
  }

  function showFilterLoading() {
    var grid = document.querySelector('#gf-products, ul.product-grid');
    if (!grid) return;
    grid.classList.add('tk-is-filtering');
    if (loadingTimeout) clearTimeout(loadingTimeout);
    loadingTimeout = setTimeout(hideFilterLoading, 6000);
  }

  function hideFilterLoading() {
    var grid = document.querySelector('#gf-products, ul.product-grid');
    if (!grid) return;
    grid.classList.remove('tk-is-filtering');
    if (loadingTimeout) { clearTimeout(loadingTimeout); loadingTimeout = null; }
  }

  function isFilterTriggerClick(target) {
    if (!target || !target.closest) return false;
    // Náš expand button — NE filter trigger, jen UI toggle.
    if (target.closest('.tk-filter-chip-more')) return false;
    // Klik na option toggle (Globo wrapping anchor pro checkbox/radio label).
    if (target.closest('#gf-tree .gf-option-box a')) return true;
    // Clear filter (X v selected-item, "Clear" link nebo "Vymazat vše" chip).
    if (target.closest('#gf-tree .gf-clear, #gf-tree .selected-item a, #gf-tree .clear-refinements, #gf-tree .gf-refine-toggle')) return true;
    // Náš preset chip (snap slideru na konkrétní hodnotu).
    if (target.closest('.tk-filter-chip')) return true;
    // Globo "Apply" button v sidebar/drawer.
    if (target.closest('#gf-tree .gf-apply, #gf-tree .gf-action button')) return true;
    return false;
  }

  var lastFilterClickTs = 0;
  document.addEventListener('click', function (e) {
    if (!isFilterTriggerClick(e.target)) return;
    lastFilterClickTs = performance.now(); // pro dedup s pushState cestou (viz correctScrollAfterFilter)
    showFilterLoading();
    // Scroll spustíme HNED na klik (ne až po morphi). Korektor drží 1. kartu
    // pod headerem už během Globo fetche (instant feedback) a po morphi plynule
    // podrží novou 1. kartu. Gate „jen když je uživatel POD začátkem produktů"
    // platí dál (alignAnchorToHeader) — nahoře u filtrů s ním nehne.
    scrollToTopForFilter();
  }, true);

  // -----------------------------------------------------------------------
  // Loading feedback na ŘAZENÍ + počet na stránku. isFilterTriggerClick výše
  // řeší jen filtr triggery; sort (Globo custom dropdown `li[data-sort]`) a
  // per-page limit (native `select.sortby-select`) re-renderují grid taky, ale
  // dosud BEZ feedbacku → uživatel přepne řazení a 2–3 s se zdánlivě nic neděje
  // (pomalá síť). Přidáme dim+spinner. BEZ scroll-to-top (na rozdíl od filtru) —
  // u řazení uživatel skok navíc nechce. gridObserver loading sundá po morphi;
  // lastFilterClickTs drží dedup s pushState cestou (žádný re-show/pulz).
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.globo-dropdown-custom__options li[data-sort]')) {
      lastFilterClickTs = performance.now();
      showFilterLoading();
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('select.sortby-select')) {
      lastFilterClickTs = performance.now();
      showFilterLoading();
    }
  }, true);

  // Při Globo morphi sundat loading a označit, že dorazily nové produkty —
  // korektor (běžící od kliku) pak smí po ustálení skončit a podrží novou kartu.
  gridObserver.disconnect();
  gridObserver = new MutationObserver(function () {
    hideFilterLoading();
    gridMutatedSinceScroll = true;
    scheduleSync();
  });
  gridObserver.observe(gridRoot, { childList: true, subtree: true });

  // Pokud Globo přijde s response a změní jen URL přes pushState (bez click
  // triggeru — např. range slider drag-end, nebo apply z mobile drawer kde
  // se klik nestihl odbavit), pendingScrollCorrection se postaral o scroll
  // v pushState patche výše. Tady zachytíme i popstate (back/forward).
  window.addEventListener('popstate', function () {
    showFilterLoading();
    setTimeout(hideFilterLoading, 2000); // popstate může být no-op, krátký fallback
  });

  // Stub aby existující reference na correctScrollAfterFilter v pushState
  // patche výše neházela ReferenceError — scroll už řeší click handler /
  // popstate, ale pushState patch (definovaný DŘÍV v souboru) volá tohle.
  function correctScrollAfterFilter() {
    if (!pendingScrollCorrection) return;
    pendingScrollCorrection = false;
    // Klik-filtry už scroll i loading řeší click handler + gridObserver. Tady
    // reagujeme JEN na non-click pushState (range slider drag-end / mobile
    // drawer apply). Jinak by se po renderu znovu rozsvítil dim (showFilterLoading)
    // + restartoval scroll → dim PULZUJE (0.45→1→0.45) = viditelný „záblesk".
    // NEvoláme showFilterLoading (re-show po renderu = pulz); jen scroll.
    if ((performance.now() - lastFilterClickTs) < 2500) return;
    scrollToTopForFilter();
  }

  // -----------------------------------------------------------------------
  // Preserve drawer scroll position when Globo re-renders the filter tree
  // after each checkbox toggle. Without this, the drawer jumps to top every
  // time a user clicks a value mid-list — especially annoying with long
  // option lists like Model zařízení (60+ entries).
  (function preserveDrawerScroll() {
    var clickAnchorId = null;
    var clickAnchorOffset = 0;
    var lastWasUserScroll = true;

    function moveWrapperIntoContents() {
      // No-op: wrapper stays at original location (sibling of .gf-filter-contents
      // inside #gf-tree) so it remains visible at top of drawer regardless
      // of scroll position. Scroll preservation is handled by click-anchor logic.
    }

    function getScrollEl() {
      var tree = document.getElementById('gf-tree');
      if (!tree) return null;
      var fc = tree.querySelector('.gf-filter-contents');
      if (fc) return fc;
      return tree;
    }

    function captureClickAnchor(target) {
      // The clicked option lives inside a .gf-option-block. That block is
      // guaranteed to exist after Globo's re-render with the same data-filter-id.
      var block = target && target.closest && target.closest('#gf-tree .gf-option-block');
      if (!block) {
        clickAnchorId = null;
        return;
      }
      var el = getScrollEl();
      if (!el) return;
      var elTop = el.getBoundingClientRect().top;
      clickAnchorId = block.getAttribute('data-filter-id') || block.getAttribute('data-filter-type') || null;
      clickAnchorOffset = block.getBoundingClientRect().top - elTop;
    }

    function restore() {
      moveWrapperIntoContents();
      if (!clickAnchorId) return;
      var el = getScrollEl();
      if (!el) return;
      var newBlock = el.querySelector('[data-filter-id="' + clickAnchorId + '"]') ||
                     el.querySelector('[data-filter-type="' + clickAnchorId + '"]');
      if (!newBlock) return;
      var elTop = el.getBoundingClientRect().top;
      var currentOffset = newBlock.getBoundingClientRect().top - elTop;
      var diff = currentOffset - clickAnchorOffset;
      if (Math.abs(diff) < 1) return;
      lastWasUserScroll = false;
      var target = el.scrollTop + diff;
      var maxScroll = el.scrollHeight - el.clientHeight;
      if (target < 0) target = 0;
      if (target > maxScroll) target = maxScroll;
      el.scrollTop = target;
      setTimeout(function () { lastWasUserScroll = true; }, 100);
    }

    function snapshot() {} // no-op — replaced by click-time captureClickAnchor

    function getTreeScrollEl() { return getScrollEl(); }

    // Capture user scroll position (capture phase — scroll doesn't bubble)
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.id === 'gf-tree' || (t.classList && t.classList.contains('gf-filter-contents')) ||
          (t.closest && t.closest('#gf-tree'))) {
        snapshot();
      }
    }, true);

    // Capture click target's block + offset just before Globo re-renders.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('#gf-tree .gf-option-block .gf-option-box a, #gf-tree .selected-item .gf-clear, #gf-tree .gf-clear, #gf-tree .gf-refine-toggle, #gf-tree .clear-refinements')) {
        captureClickAnchor(t);
      }
    }, true);

    // Restore after Globo re-renders the tree (DOM mutation). Schedule via
    // rAF so we run after layout settles, and retry a few frames in case
    // Globo re-renders blocks incrementally.
    var restoreScheduled = false;
    var restoreAttempts = 0;
    function scheduleRestore() {
      if (restoreScheduled) return;
      restoreScheduled = true;
      restoreAttempts = 0;
      function tick() {
        restore();
        restoreAttempts++;
        if (restoreAttempts < 6) {
          requestAnimationFrame(tick);
        } else {
          restoreScheduled = false;
        }
      }
      requestAnimationFrame(tick);
    }
    var treeContentObserver = new MutationObserver(scheduleRestore);
    function startObserver() {
      var tree = document.getElementById('gf-tree');
      if (!tree) return setTimeout(startObserver, 300);
      treeContentObserver.observe(tree, { childList: true, subtree: true });
    }
    startObserver();
  })();

  // -----------------------------------------------------------------------
  // Empty-result rescue: when user toggles filters to a combination that
  // returns 0 products (especially with AND logic), Globo wipes the entire
  // filter tree — user can't see what they selected or uncheck. Detect that
  // state via .spf-empty body class (or 0 visible filter blocks) and inject
  // a small panel showing active filters + a "Clear all" link.
  // Locale-aware copy for the empty-rescue panel + booleans.
  // Globo serves CS in URL even on EN locale, so we translate values via
  // translationsMap (when loaded). 'Skladem' (boolean filter value=1) is a
  // hardcoded special case — also locale-aware.
  var EMPTY_RESCUE_COPY = {
    en: {
      title: 'No products match',
      subtitle: 'The selected filter combination returned no results.',
      clearAll: 'Clear all filters',
      inStock: 'In Stock',
    },
    cs: {
      title: 'Žádný produkt nevyhovuje',
      subtitle: 'Zvolená kombinace filtrů nemá žádný výsledek.',
      clearAll: 'Vymazat všechny filtry',
      inStock: 'Skladem',
    },
    sk: {
      title: 'Žiadny produkt nevyhovuje',
      subtitle: 'Zvolená kombinácia filtrov nemá žiadny výsledok.',
      clearAll: 'Vymazať všetky filtre',
      inStock: 'Skladom',
    },
  };
  function getEmptyRescueCopy() {
    var lang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
    return EMPTY_RESCUE_COPY[lang] || EMPTY_RESCUE_COPY.cs;
  }

  function getActiveFiltersFromUrl() {
    var url = new URL(window.location.href);
    var copy = getEmptyRescueCopy();
    var filters = [];
    url.searchParams.forEach(function (val, key) {
      if (/^gf_\d+$/.test(key) && val) {
        val.split(',').forEach(function (v) {
          v = decodeURIComponent(v).trim();
          if (v && v !== '0' && v !== '1') {
            // Translate via map if available (e.g. 'Mikrovlákno' → 'Microfiber')
            var translated = (IS_EN_LOCALE && translationsMap && translationsMap[v]) || v;
            filters.push({ key: key, value: translated });
          } else if (v === '1' && key) {
            filters.push({ key: key, value: copy.inStock });
          }
        });
      }
    });
    return filters;
  }

  function isEmptyState() {
    if (document.documentElement.classList.contains('spf-empty')) return true;
    if (document.body.classList.contains('spf-empty')) return true;
    var tree = document.getElementById('gf-tree');
    if (!tree) return false;
    var blocks = tree.querySelectorAll('.gf-option-block');
    var filters = getActiveFiltersFromUrl();
    return blocks.length === 0 && filters.length > 0;
  }

  function ensureEmptyRescue() {
    var existing = document.getElementById('tk-empty-rescue');
    if (!isEmptyState()) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    var contents = document.querySelector('#gf-tree .gf-filter-contents') || document.getElementById('gf-tree');
    if (!contents) return;
    var filters = getActiveFiltersFromUrl();
    var url = new URL(window.location.href);
    [...url.searchParams.keys()].forEach(function (k) {
      if (/^gf_/.test(k)) url.searchParams.delete(k);
    });
    var clearAllUrl = url.toString();
    var div = document.createElement('div');
    div.id = 'tk-empty-rescue';
    div.style.cssText = 'padding:24px 16px;text-align:center;color:#0a0a0a;';
    var chipsHtml = filters.map(function (f) {
      return '<span style="display:inline-flex;align-items:center;padding:6px 12px;margin:4px;border:1px solid #e5e5e5;border-radius:999px;background:#fafafa;font-size:12px;">' +
        f.value + '</span>';
    }).join('');
    var copy = getEmptyRescueCopy();
    div.innerHTML =
      '<div style="font-size:14px;font-weight:600;margin-bottom:8px;">' + copy.title + '</div>' +
      '<div style="font-size:13px;color:#6b6b6b;margin-bottom:12px;">' + copy.subtitle + '</div>' +
      '<div style="margin-bottom:14px;display:flex;flex-wrap:wrap;justify-content:center;gap:4px;">' + chipsHtml + '</div>' +
      '<a href="' + clearAllUrl + '" style="display:inline-block;padding:10px 18px;border:1px solid #0a0a0a;border-radius:999px;background:#fff;font-size:13px;font-weight:600;color:#0a0a0a;text-decoration:none;">' + copy.clearAll + '</a>';
    contents.appendChild(div);
  }

  var emptyObserver = new MutationObserver(function () { ensureEmptyRescue(); });
  function startEmptyObserver() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return setTimeout(startEmptyObserver, 300);
    emptyObserver.observe(tree, { childList: true, subtree: true, attributeFilter: ['class'] });
    emptyObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    ensureEmptyRescue();
  }
  startEmptyObserver();

  // Run as early as possible
  injectControlBarStyles();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectControlBarStyles);
  }

  function parseNum(s) {
    if (s == null) return NaN;
    var t = String(s).trim().replace(/\s+/g, '').replace(',', '.');
    if (t === '') return NaN;
    var n = parseFloat(t);
    return isFinite(n) ? n : NaN;
  }

  // Pinned-first labels for boolean / known filters. Lowercased, both CS+EN.
  // Items matching these labels are moved to the top in this exact order.
  var PINNED_FIRST = [
    'skladem', 'in stock',
    'není skladem', 'not in stock', 'out of stock',
  ];

  function getLabelText(li) {
    var labelEl = li.querySelector('.gf-label, .gf-option-value');
    return labelEl ? labelEl.textContent.trim() : '';
  }

  function sortBlock(block) {
    var list = block.querySelector('.gf-option-box');
    if (!list) return;
    var items = [];
    var hidden = [];
    var children = list.children;
    for (var i = 0; i < children.length; i++) {
      var li = children[i];
      if (li.tagName !== 'LI') continue;
      if (li.classList.contains('hidden-box')) { hidden.push(li); continue; }
      items.push(li);
    }
    if (items.length < 2) return;

    var sorted = null;

    // 1) Pinned-first reorder: if every item's label matches a pinned key,
    //    reorder by the PINNED_FIRST priority. Covers boolean filters like
    //    Dostupnost (Skladem / Není skladem).
    var pinnedHits = items.map(function (li) {
      return PINNED_FIRST.indexOf(getLabelText(li).toLowerCase());
    });
    if (pinnedHits.every(function (idx) { return idx >= 0; })) {
      var pairs = items.map(function (li, i) { return { li: li, p: pinnedHits[i] }; });
      pairs.sort(function (a, b) { return a.p - b.p; });
      sorted = pairs.map(function (p) { return p.li; });
    }

    // 2) Numeric sort fallback: if all labels parse as numbers, sort ascending.
    if (!sorted) {
      var nums = [];
      var allNumeric = true;
      for (var j = 0; j < items.length; j++) {
        var n = parseNum(getLabelText(items[j]));
        if (isNaN(n)) { allNumeric = false; break; }
        nums.push({ li: items[j], n: n });
      }
      if (allNumeric) {
        nums.sort(function (a, b) { return a.n - b.n; });
        sorted = nums.map(function (p) { return p.li; });
      }
    }

    // Zaznamenej režim řazení bloku. Běží na CZ labelech (Globo rendruje primární
    // jazyk), takže pinned/numeric detekce je spolehlivá ještě před EN přepisem.
    // Text-value bloky se v EN přeřadí podle přeloženého labelu — viz
    // resortByTranslatedLabel() volané z rewriteLabels(). pinned/numeric bloky
    // si svůj řád drží (čísla se nepřekládají, pinned pořadí je explicitní).
    block.setAttribute('data-tk-sortmode', sorted ? (pinnedHits.every(function (idx) { return idx >= 0; }) ? 'pinned' : 'numeric') : 'text');

    if (!sorted) return;

    var alreadySorted = true;
    for (var k = 0; k < sorted.length; k++) {
      if (sorted[k] !== items[k]) { alreadySorted = false; break; }
    }
    if (alreadySorted) return;

    var frag = document.createDocumentFragment();
    for (var m = 0; m < sorted.length; m++) frag.appendChild(sorted[m]);
    for (var h = 0; h < hidden.length; h++) frag.appendChild(hidden[h]);
    list.appendChild(frag);
  }

  function formatNum(n) {
    try { return Number(n).toLocaleString('cs-CZ'); }
    catch (e) { return String(n); }
  }

  function fireChange(el) {
    try { el.dispatchEvent(new Event('change', { bubbles: true })); }
    catch (e) {
      var ev = document.createEvent('Event');
      ev.initEvent('change', true, true);
      el.dispatchEvent(ev);
    }
  }

  // Globo's slider has THREE listeners: noUiSlider.on('change'), and 'change' on
  // the min + max text inputs. noUiSlider.set() fires 'set' (not 'change'), so
  // programmatic .set() does NOT trigger the filter. The text-input 'change'
  // handler reads the OTHER input's current value when clamping the pair, so
  // we must update both inputs BEFORE dispatching change on either.
  function setSliderRange(block, minVal, maxVal) {
    var minInput = block.querySelector('.gf-range-min');
    var maxInput = block.querySelector('.gf-range-max');
    if (!minInput || !maxInput) return;

    minInput.value = minVal;
    minInput.setAttribute('data-value', minVal);
    maxInput.value = maxVal;
    maxInput.setAttribute('data-value', maxVal);

    var slider = block.querySelector('.gf-range-slider');
    if (slider && slider.noUiSlider && typeof slider.noUiSlider.set === 'function') {
      try { slider.noUiSlider.set([Number(minVal), Number(maxVal)]); } catch (e) { /* noop */ }
    }

    // Fire change on max input — this hits Globo's listener which calls
    // addRangeFilter(filterId, "min:max") and applies the filter.
    fireChange(maxInput);
  }

  function syncChipActive(block) {
    var minInput = block.querySelector('.gf-range-min');
    var maxInput = block.querySelector('.gf-range-max');
    if (!minInput || !maxInput) return;
    var minV = parseNum(minInput.value);
    var maxV = parseNum(maxInput.value);
    var minBound = parseNum(minInput.getAttribute('data-min-value'));
    var maxBound = parseNum(maxInput.getAttribute('data-max-value'));
    var atFullRange = minV === minBound && maxV === maxBound;
    var isPoint = !isNaN(minV) && minV === maxV && !atFullRange;
    var chips = block.querySelectorAll('.tk-filter-chip');
    for (var i = 0; i < chips.length; i++) {
      var v = parseNum(chips[i].getAttribute('data-value'));
      if (isPoint && v === minV) chips[i].classList.add('is-active');
      else chips[i].classList.remove('is-active');
    }
  }

  // ----- Dynamic preset values per collection ------------------------------
  // Fetched once per page load from /<collection-path>?section_id=tk-filter-values
  // (section returns JSON of unique metafield values across collection.products).
  // Cache shape: { kapacita_mah: [3000, 5000, 10000, ...] } or {} on miss.
  var tkFilterValuesCache = null;
  var tkFilterValuesLoading = null;

  // Cap multi-page fetches at 10 pages × 50 = 500 produktů, abychom u velkých
  // kolekcí typu /collections/all neudělali 20+ paralelních requestů.
  var FILTER_VALUES_MAX_PAGES = 10;

  function parseFilterValuesPage(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var script = doc.querySelector('script[data-tk-filter-values]');
      if (!script) return { data: {}, pages: 1 };
      var data = JSON.parse(script.textContent) || {};
      var pages = parseInt(script.getAttribute('data-pages'), 10) || 1;
      return { data: data, pages: pages };
    } catch (e) {
      return { data: {}, pages: 1 };
    }
  }

  function mergeFilterValues(acc, next) {
    for (var key in next) {
      if (!Object.prototype.hasOwnProperty.call(next, key)) continue;
      var arr = next[key];
      if (!arr || !arr.length) continue;
      if (!acc[key]) acc[key] = [];
      for (var i = 0; i < arr.length; i++) {
        if (acc[key].indexOf(arr[i]) === -1) acc[key].push(arr[i]);
      }
    }
    return acc;
  }

  function loadFilterValues() {
    if (tkFilterValuesCache) return Promise.resolve(tkFilterValuesCache);
    if (tkFilterValuesLoading) return tkFilterValuesLoading;
    var path = window.location.pathname;
    // Match /collections/<handle> with optional 2-char locale prefix.
    var m = path.match(/^(?:\/[a-z]{2})?\/collections\/[^/]+/);
    if (!m) {
      tkFilterValuesCache = {};
      return Promise.resolve(tkFilterValuesCache);
    }
    var basePath = m[0];
    var firstUrl = basePath + '?section_id=tk-filter-values';

    tkFilterValuesLoading = fetch(firstUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var first = parseFilterValuesPage(html);
        var merged = {};
        mergeFilterValues(merged, first.data);

        // Pokud kolekce má jen 1 stránku, jsme hotoví.
        if (first.pages <= 1) return merged;

        // Paralelně dotáhnout page 2..min(pages, MAX). Cap nás chrání před
        // runaway na velkých kolekcích (`/collections/all` může mít 1000+
        // produktů; 10 stránek × 50 = 500 vzorek je dost na pokrytí běžných
        // hodnot kapacity, vzácné okraje mohou chybět).
        var maxPage = Math.min(first.pages, FILTER_VALUES_MAX_PAGES);
        var promises = [];
        for (var p = 2; p <= maxPage; p++) {
          promises.push(
            fetch(basePath + '?section_id=tk-filter-values&page=' + p, { credentials: 'same-origin' })
              .then(function (r) { return r.ok ? r.text() : ''; })
              .then(function (h) { return parseFilterValuesPage(h).data; })
              .catch(function () { return {}; })
          );
        }
        return Promise.all(promises).then(function (results) {
          for (var i = 0; i < results.length; i++) mergeFilterValues(merged, results[i]);
          return merged;
        });
      })
      .then(function (merged) {
        tkFilterValuesCache = merged || {};
        // Re-render any presets that deferred while waiting on this fetch.
        var blocks = document.querySelectorAll('.gf-option-block');
        for (var i = 0; i < blocks.length; i++) renderPresets(blocks[i]);
        return tkFilterValuesCache;
      })
      .catch(function () {
        tkFilterValuesCache = {};
        return tkFilterValuesCache;
      });
    return tkFilterValuesLoading;
  }

  var PRESETS_VISIBLE = 3;

  function renderPresets(block) {
    var container = block.querySelector('.tk-filter-presets');
    if (!container) return;
    if (container.getAttribute('data-tk-rendered') === '1') {
      syncChipActive(block);
      return;
    }

    var unit = container.getAttribute('data-unit') || '';
    var key = container.getAttribute('data-key') || '';

    // Prefer dynamic per-collection values when data-key is present.
    var values = null;
    if (key) {
      if (!tkFilterValuesCache) {
        // Fetch in flight (or kicked off now) — defer; we'll be re-called.
        loadFilterValues();
        return;
      }
      var dyn = tkFilterValuesCache[key];
      if (dyn && dyn.length) values = dyn.slice();
    }
    if (!values) {
      var raw = container.getAttribute('data-presets') || '';
      values = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    if (!values.length) return;

    // Numeric parse + sort asc.
    var numeric = [];
    for (var i = 0; i < values.length; i++) {
      var n = parseNum(values[i]);
      if (!isNaN(n)) numeric.push(n);
    }
    numeric.sort(function (a, b) { return a - b; });

    // Filter out values outside the slider's actual data bounds.
    var sliderEl = block.querySelector('.gf-range-slider');
    var sliderMin = sliderEl ? parseNum(sliderEl.getAttribute('data-min')) : NaN;
    var sliderMax = sliderEl ? parseNum(sliderEl.getAttribute('data-max')) : NaN;
    if (!isNaN(sliderMin) && !isNaN(sliderMax)) {
      numeric = numeric.filter(function (v) { return v >= sliderMin && v <= sliderMax; });
    }
    if (!numeric.length) return;

    // Collapse to PRESETS_VISIBLE only if there are >1 hidden (otherwise
    // a "+1" toggle costs the same space as showing the chip directly).
    var hiddenCount = numeric.length - PRESETS_VISIBLE;
    var hasMore = hiddenCount > 1;

    var html = '';
    for (var k = 0; k < numeric.length; k++) {
      var v = numeric[k];
      var label = formatNum(v) + (unit ? ' ' + unit : '');
      var cls = 'tk-filter-chip';
      if (hasMore && k >= PRESETS_VISIBLE) cls += ' is-collapsed';
      html += '<button type="button" class="' + cls + '" data-value="' + v + '">' + label + '</button>';
    }
    if (hasMore) {
      html += '<button type="button" class="tk-filter-chip-more" data-tk-presets-expand>+' + hiddenCount + '</button>';
    }
    container.innerHTML = html;
    container.setAttribute('data-tk-rendered', '1');

    container.addEventListener('click', function (e) {
      var more = e.target && e.target.closest ? e.target.closest('.tk-filter-chip-more') : null;
      if (more) {
        e.preventDefault();
        var collapsed = container.querySelectorAll('.tk-filter-chip.is-collapsed');
        for (var j = 0; j < collapsed.length; j++) collapsed[j].classList.remove('is-collapsed');
        if (more.parentNode) more.parentNode.removeChild(more);
        return;
      }
      var chip = e.target && e.target.closest ? e.target.closest('.tk-filter-chip') : null;
      if (!chip) return;
      e.preventDefault();
      var v = chip.getAttribute('data-value');
      setSliderRange(block, v, v);
      // Optimistic active highlight; final sync runs on next scan tick.
      var siblings = block.querySelectorAll('.tk-filter-chip');
      for (var j2 = 0; j2 < siblings.length; j2++) siblings[j2].classList.remove('is-active');
      chip.classList.add('is-active');
    });

    var minInput = block.querySelector('.gf-range-min');
    var maxInput = block.querySelector('.gf-range-max');
    if (minInput) minInput.addEventListener('change', function () { syncChipActive(block); });
    if (maxInput) maxInput.addEventListener('change', function () { syncChipActive(block); });

    syncChipActive(block);
  }

  // Kick off the values fetch ASAP so the first scan can already render
  // dynamic presets instead of deferring.
  loadFilterValues();

  // ----- EN locale: rewrite filter values (Globo backend ignores Shopify
  //       metaobject translations and serves CS even on locale=en). We
  //       eager-load CS→EN map at IIFE init (NOT lazy on first scan) and
  //       post-process .gf-label texts on every Globo render. -----------
  var translationsMap = null;
  var translationsLoading = null;
  // Primární jazyk obchodu je čeština — Globo servíruje CS vždy, takže rewrite
  // potřebuje KAŽDÝ ostatní jazyk (en, sk, …), ne jen angličtina. Mapu volí
  // meta[name=tk-globo-translations-url], kterou skládá snippets/stylesheets.liquid
  // podle request.locale.iso_code.
  var PAGE_LANG = (document.documentElement.lang || 'cs').toLowerCase().slice(0, 2);
  var IS_EN_LOCALE = PAGE_LANG !== 'cs';

  function loadTranslations() {
    if (translationsMap) return Promise.resolve(translationsMap);
    if (translationsLoading) return translationsLoading;
    var meta = document.querySelector('meta[name="tk-globo-translations-url"]');
    var url = meta && meta.getAttribute('content');
    if (!url) {
      translationsMap = {};
      return Promise.resolve(translationsMap);
    }
    translationsLoading = fetch(url)
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (m) {
        translationsMap = m || {};
        // As soon as the map arrives, rewrite anything Globo already
        // rendered while we were waiting (the original CS→EN flash).
        if (IS_EN_LOCALE) rewriteLabels();
        return translationsMap;
      });
    return translationsLoading;
  }

  // Kick off the fetch ASAP — don't wait for the first Globo render.
  // Without this, on cold cache the labels stay CS for ~1–2s after the
  // tree renders (race window users see as "labels in Czech").
  if (IS_EN_LOCALE) loadTranslations();

  // ─── Color swatch map (Globo Barva filter color circles) ─────────────────
  // Map { "Černá": "#0a0a0a", ... } z shopify--color-pattern metaobjektů.
  // Globo filter pro `product.shopify.color-pattern` metafield neumí
  // auto-extrahovat hex z metaobject.color → injectneme kuličky client-side
  // přes label-text → hex lookup. Build skript: scripts/build-color-swatch-map.mjs.
  var colorSwatchMap = null;
  var colorSwatchLoading = null;

  function loadColorSwatchMap() {
    if (colorSwatchMap) return Promise.resolve(colorSwatchMap);
    if (colorSwatchLoading) return colorSwatchLoading;
    /* Fetch ze section endpointu — Liquid server-side čerpá z
       shop.metaobjects['shopify--color-pattern'].values, takže žádný build
       neni potřeba. Když admin přidá novou barvu v Shopify, příští fetch
       ji obsahuje. Fetch z '/' = CS default locale (mapa CS-keyed).
       Shopify wrapne obsah do <div class="shopify-section">; potřebujeme
       extrahovat JSON z inner content. */
    colorSwatchLoading = fetch('/?section_id=tk-color-swatch-map', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; })
      .then(function (html) {
        var map = {};
        if (html) {
          /* Shopify wrap je <div id="shopify-section-..." class="shopify-section ...">JSON</div>.
             Najdi první { a parsuj substr. */
          var i = html.indexOf('{');
          var j = html.lastIndexOf('}');
          if (i !== -1 && j > i) {
            try { map = JSON.parse(html.substring(i, j + 1)); } catch (e) { map = {}; }
          }
        }
        colorSwatchMap = map;
        injectColorSwatches();
        return colorSwatchMap;
      });
    return colorSwatchLoading;
  }
  loadColorSwatchMap();

  function lookupColorHex(label) {
    if (!colorSwatchMap || !label) return null;
    var txt = label.trim();
    // Direct CS lookup
    if (colorSwatchMap[txt]) return colorSwatchMap[txt];
    // EN reverse: zkus přes translationsMap (en → cs) → hex
    if (translationsMap) {
      for (var cs in translationsMap) {
        if (translationsMap[cs] === txt && colorSwatchMap[cs]) return colorSwatchMap[cs];
      }
    }
    return null;
  }

  /* Inject color circles do Globo Barva filtru. Detekce color filter blocku
     přes data-filter-type ending na 'color-pattern' (matchne 'product.shopify.color-pattern',
     'shopify--color-pattern', atd.) nebo data-filter-id obsahující 'color' / 'barva'. */
  function isColorFilterBlock(block) {
    if (!block || !block.getAttribute) return false;
    var t = (block.getAttribute('data-filter-type') || '').toLowerCase();
    var id = (block.getAttribute('data-filter-id') || '').toLowerCase();
    if (t.indexOf('color-pattern') !== -1) return true;
    if (t.indexOf('barva') !== -1) return true;
    if (t.indexOf('color') !== -1 && t.indexOf('colour') === -1) {
      // Avoid matching unrelated filters like "color_scheme" — require explicit hint
      if (t.indexOf('shopify.color') !== -1 || t.indexOf('product_color') !== -1 || t === 'color') return true;
    }
    // Fallback: check block title text contains "Barva" / "Color"
    var titleEl = block.querySelector('.gf-block-title, .gf-block-title .h3, h3');
    if (titleEl) {
      var titleTxt = (titleEl.textContent || '').trim().toLowerCase();
      if (titleTxt === 'barva' || titleTxt === 'color' || titleTxt === 'farba' || titleTxt === 'barva mobilu') {
        return true;
      }
    }
    return false;
  }

  function injectColorSwatches(root) {
    if (!colorSwatchMap) return;
    var blocks = (root || document).querySelectorAll('#gf-tree .gf-option-block');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (!isColorFilterBlock(block)) continue;
      var items = block.querySelectorAll('.gf-option-box > li > a, .gf-option-box .gf-option-label');
      for (var j = 0; j < items.length; j++) {
        var a = items[j];
        if (a.querySelector('.tk-gf-color-circle')) continue;
        // Label text — preferuj .gf-label/.gf-option-value child, jinak textContent
        var labelEl = a.querySelector('.gf-label, .gf-option-value');
        var labelTxt = labelEl ? (labelEl.textContent || '').trim() : (a.textContent || '').trim();
        if (!labelTxt) continue;
        var hex = lookupColorHex(labelTxt);
        if (!hex) continue;
        var circle = document.createElement('span');
        circle.className = 'tk-gf-color-circle';
        circle.setAttribute('aria-hidden', 'true');
        circle.style.background = hex;
        // Pro velmi světlé barvy (bílá, čirá) přidej ring pro viditelnost
        if (/^#(f[0-9a-f]{2}|fff)/i.test(hex)) {
          circle.classList.add('tk-gf-color-circle--light');
        }
        a.insertBefore(circle, a.firstChild);
      }
    }
    // Also active "selected items" pills nahoře
    var pills = (root || document).querySelectorAll('#gf-tree .selected-item.gf-option-label');
    for (var k = 0; k < pills.length; k++) {
      var p = pills[k];
      if (p.querySelector('.tk-gf-color-circle')) continue;
      // Pro selected items dataset přes parent filter block type
      var anchor = p.querySelector('a') || p;
      var lblEl = anchor.querySelector('.gf-label');
      var lblTxt = lblEl ? (lblEl.textContent || '').trim() : '';
      if (!lblTxt) continue;
      var hex2 = lookupColorHex(lblTxt);
      if (!hex2) continue;
      var c2 = document.createElement('span');
      c2.className = 'tk-gf-color-circle tk-gf-color-circle--pill';
      c2.setAttribute('aria-hidden', 'true');
      c2.style.background = hex2;
      if (/^#(f[0-9a-f]{2}|fff)/i.test(hex2)) c2.classList.add('tk-gf-color-circle--light');
      anchor.insertBefore(c2, anchor.firstChild);
    }
  }

  function rewriteLabels(root) {
    if (!IS_EN_LOCALE || !translationsMap) return;
    // NOTE: we do NOT skip already-rewritten elements — Globo can re-render
    // an existing `.gf-label` span by replacing only its textContent, which
    // would leave our `data-tk-rewritten` attr in place but with CS text.
    // Instead, only skip when the current text already matches the EN value.
    // `.h3` = nadpis filtračního bloku („Dostupnost", „Délka kabelu (m)").
    // Globo je servíruje česky stejně jako hodnoty a nejsou to Shopify FILTER
    // resources, takže se přepisují ze stejné mapy (statická část v
    // scripts/_globo-extra-labels.mjs). Text sedí na vnořeném <span>.
    var nodes = (root || document).querySelectorAll('#gf-tree .gf-label, #gf-tree .gf-option-value, #gf-tree .h3 span');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var txt = (el.textContent || '').trim();
      if (!txt) continue;
      var en = translationsMap[txt];
      if (en && txt !== en) {
        el.textContent = en;
        el.setAttribute('data-tk-rewritten', '1');
      }
    }
    // Also rewrite the "selected items" pills in the active filters area.
    var pills = (root || document).querySelectorAll('#gf-tree .selected-item .gf-label');
    for (var j = 0; j < pills.length; j++) {
      var p = pills[j];
      var t2 = (p.textContent || '').trim();
      if (!t2) continue;
      var en2 = translationsMap[t2];
      if (en2 && t2 !== en2) {
        p.textContent = en2;
        p.setAttribute('data-tk-rewritten', '1');
      }
    }
    // Po přepisu labelů přeřaď text-value bloky podle EN abecedy.
    resortByTranslatedLabel(root);
  }

  // Globo třídí hodnoty filtrů server-side podle labelu primárního jazyka (CZ).
  // V EN se label přepisuje až client-side (rewriteLabels), takže pořadí zůstane
  // „české" → v EN to nevypadá podle abecedy. Tady text-value bloky přeřadíme
  // podle aktuálního (přeloženého) labelu. pinned/numeric bloky přeskoč —
  // jejich pořadí překlad nemění (data-tk-sortmode nastavuje sortBlock na CZ
  // labelech ještě před přepisem).
  var EN_COLLATOR = (function () {
    try { return new Intl.Collator(PAGE_LANG, { numeric: true, sensitivity: 'base' }); }
    catch (e) { return null; }
  })();

  function resortByTranslatedLabel(root) {
    if (!IS_EN_LOCALE) return;
    var blocks = (root || document).querySelectorAll('#gf-tree .gf-option-block');
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var mode = block.getAttribute('data-tk-sortmode');
      if (mode === 'pinned' || mode === 'numeric') continue;
      var list = block.querySelector('.gf-option-box');
      if (!list) continue;
      var items = [];
      var hidden = [];
      var ch = list.children;
      for (var i = 0; i < ch.length; i++) {
        var li = ch[i];
        if (li.tagName !== 'LI') continue;
        if (li.classList.contains('hidden-box')) { hidden.push(li); continue; }
        items.push(li);
      }
      if (items.length < 2) continue;
      var withLabel = items.map(function (li) { return { li: li, t: getLabelText(li) }; });
      // Čisté swatche bez textového labelu nelze abecedně seřadit → nech být.
      if (withLabel.some(function (x) { return !x.t; })) continue;
      var sorted = withLabel.slice().sort(function (a, c) {
        return EN_COLLATOR ? EN_COLLATOR.compare(a.t, c.t) : a.t.localeCompare(c.t);
      }).map(function (x) { return x.li; });
      var same = true;
      for (var k = 0; k < sorted.length; k++) {
        if (sorted[k] !== items[k]) { same = false; break; }
      }
      if (same) continue;
      var frag = document.createDocumentFragment();
      for (var m = 0; m < sorted.length; m++) frag.appendChild(sorted[m]);
      for (var h = 0; h < hidden.length; h++) frag.appendChild(hidden[h]);
      list.appendChild(frag);
    }
  }

  function scan() {
    var blocks = document.querySelectorAll('.gf-option-block');
    for (var i = 0; i < blocks.length; i++) {
      sortBlock(blocks[i]);
      renderPresets(blocks[i]);
      hookCzkSliderNormalization(blocks[i]);
      hookRangeInputPreRead(blocks[i]);
    }
    // CZK range input normalization (běží i z runSync, ale gridObserver sleduje
    // jen #gf-products — filter inputs jsou v #gf-tree, takže bez tohoto by se
    // po každém rebuildu tree input value vrátil na "2,799.00".
    normalizeCzkGloboRangeInputs();
    normalizeEurGloboRangeInputs();
    normalizeCzkNoUiLabels();
    reconcileStaleSliderRanges();
    stripCurrencyFromNonPriceSliders();
    if (IS_EN_LOCALE) {
      if (!translationsMap) loadTranslations().then(function () { rewriteLabels(); });
      else rewriteLabels();
    }
    if (!colorSwatchMap) loadColorSwatchMap().then(function () { injectColorSwatches(); });
    else injectColorSwatches();
  }

  // Hook noUiSlider 'update' event tak aby normalize* běžely při každém pohybu
  // slideru (drag, set, page-load init). Globo sets input.value přes JS property
  // (ne attribute) což MutationObserver nezachytí. Idempotent přes _tkNormHooked.
  function hookCzkSliderNormalization(block) {
    if (!block) return;
    var slider = block.querySelector('.gf-range-slider');
    if (!slider || !slider.noUiSlider || slider._tkNormHooked) return;
    if (typeof slider.noUiSlider.on !== 'function') return;
    slider._tkNormHooked = true;
    var renorm = function () {
      normalizeCzkGloboRangeInputs(block);
      normalizeEurGloboRangeInputs(block);
      normalizeCzkNoUiLabels(block);
      stripCurrencyFromNonPriceSliders(block);
    };
    // 'update' = každá změna hodnoty; 'slide'/'drag' = aktivní tažení. Globo
    // zapisuje surovou 2-decimal hodnotu do buňky na 'slide' (fíruje PO 'update')
    // → buňka během tažení ukazovala "1737.64" než ji release přepočítal. Náš
    // listener se registruje AŽ PO Globově (slider už existuje), takže pro daný
    // event fíruje po něm → zaokrouhlí (CZK floor/ceil) hned při tažení. Tím se
    // buňka drží celočíselná po celou dobu dragu, ne až po puštění.
    slider.noUiSlider.on('update', renorm);
    slider.noUiSlider.on('slide', renorm);
    slider.noUiSlider.on('drag', renorm);
  }

  // Capture-phase 'change' listener na .gf-range-min/.gf-range-max co PŘED Globo
  // readem přepíše input.value z formátované podoby ("5 000" / "7,95") na raw
  // parseFloat-compatible string ("5000" / "7.95"). Bez toho Globo's change
  // handler dělá parseFloat("5 000") → 5 a filtr se aplikuje na max=5 místo 5000.
  // Probém: normalizeCzkGloboRangeInputs / normalizeEurGloboRangeInputs reformátují
  // input.value mezerou / čárkou, což je hezké pro display ale rozbije parsing.
  // Tato funkce běží jako capture-phase listener — DOM spec garantuje že capture
  // listeners na target elementu fire před bubble listeners (Globo registruje
  // default = bubble), takže náš override raw hodnoty Globo uvidí.
  // Po runSync (gridObserver / pushState) se normalize zase aplikuje a input
  // zobrazuje pretty hodnotu pro user-facing display.
  function preReadNormalizeValue(input) {
    if (!input) return;
    var raw = (input.value || '').trim();
    if (!raw) return;
    var clean = raw.replace(/[\s ]/g, '');
    var hasComma = clean.indexOf(',') >= 0;
    var hasDot = clean.indexOf('.') >= 0;
    if (hasComma && hasDot) {
      clean = clean.replace(/,/g, '');
    } else if (hasComma) {
      if (/,\d{1,2}$/.test(clean)) {
        clean = clean.replace(',', '.');
      } else {
        clean = clean.replace(/,/g, '');
      }
    }
    var num = parseFloat(clean);
    if (isNaN(num)) return;
    var next = String(num);
    if (input.value !== next) input.value = next;
  }

  // Globo's change handler reads BOTH inputs (min + max) v ramci .gf-option-block,
  // takze kdyz change fire jen na jednom (napr. po fireChange(maxInput) v setSliderRange),
  // musime normalize oba sourozence -- jinak Globo cte stale "5 000" z toho druheho
  // a parseFloat -> 5.
  function preReadNormalize(e) {
    var input = e.target;
    if (!input || (!input.classList.contains('gf-range-min') && !input.classList.contains('gf-range-max'))) return;
    var block = input.closest && input.closest('.gf-option-block');
    if (block) {
      var pair = block.querySelectorAll('.gf-range-min, .gf-range-max');
      for (var i = 0; i < pair.length; i++) preReadNormalizeValue(pair[i]);
    } else {
      preReadNormalizeValue(input);
    }
  }

  function hookRangeInputPreRead(block) {
    if (!block) return;
    var inputs = block.querySelectorAll('.gf-range-min, .gf-range-max');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input._tkPreReadHooked) continue;
      input._tkPreReadHooked = true;
      input.addEventListener('change', preReadNormalize, true);
    }
  }

  // ----- Tablet drawer mode (≤1024px) ---------------------------------------
  // Reuse Globo's built-in .gf-offcanvas system (same drawer used at <=480
  // by default, including the gf-overlay backdrop). We just toggle the
  // body class at our breakpoint so Globo's CSS kicks in earlier.

  var DRAWER_MAX = 1024;

  function isTablet() { return window.innerWidth <= DRAWER_MAX; }

  function syncOffcanvasMode() {
    // Globo's toggleCanvas() toggles 'offcanvas-open' on <html>, and the
    // rule .gf-offcanvas.offcanvas-open #gf-tree { left: 0 } needs both
    // classes on the SAME element. So add gf-offcanvas to <html>, not body.
    var html = document.documentElement;
    var tablet = isTablet();
    var has = html.classList.contains('gf-offcanvas');
    if (tablet && !has) {
      html.classList.add('gf-offcanvas');
    } else if (!tablet && has) {
      html.classList.remove('gf-offcanvas', 'offcanvas-open');
    }
  }

  syncOffcanvasMode();
  window.addEventListener('resize', syncOffcanvasMode);
  document.addEventListener('DOMContentLoaded', syncOffcanvasMode);
  window.addEventListener('load', syncOffcanvasMode);

  // Globo's init re-writes <html> className wholesale and wipes our class.
  // Watch for class changes and re-apply (idempotent — won't loop because
  // syncOffcanvasMode only mutates when state differs).
  var htmlClassObserver = new MutationObserver(syncOffcanvasMode);
  htmlClassObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  // ESC key closes the drawer (Globo's own toggleCanvas if available).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!document.body.classList.contains('offcanvas-open')) return;
    if (window.globofilter && typeof window.globofilter.toggleCanvas === 'function') {
      window.globofilter.toggleCanvas();
    } else {
      document.body.classList.remove('offcanvas-open');
    }
  });

  // Click on Globo's auto-injected #gf-overlay → close. Globo's own JS
  // handles this in some themes but not all; safe to add as fallback.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.id === 'gf-overlay' || e.target.closest('#gf-overlay')) {
      if (window.globofilter && typeof window.globofilter.toggleCanvas === 'function') {
        window.globofilter.toggleCanvas();
      } else {
        document.body.classList.remove('offcanvas-open');
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; scan(); });
  }

  var observer = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('.gf-option-block, .gf-option-box, li')) ||
            (node.querySelector && node.querySelector('.gf-option-block'))) {
          schedule();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Dedicated observer on #gf-tree — fires on ANY mutation (add/remove/text)
  // inside the filter tree. Globo's narrow-down re-render replaces .gf-option-box
  // with a new wrapper (.gf-scroll > .gf-option-box) that the document-level
  // observer above misses, AND uses textContent updates that childList ignores.
  // This guarantees scan() runs whenever the tree changes shape or content.
  function startTreeContentScanObserver() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return setTimeout(startTreeContentScanObserver, 300);
    var treeScanObserver = new MutationObserver(function () { schedule(); });
    treeScanObserver.observe(tree, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
  startTreeContentScanObserver();
})();
/* sync trigger 1778052008 */
